<template>
  <el-container>
    <div class="topebanner"></div>
    <el-page-header @back="goBack"></el-page-header>
    <div class="bg-box">
      <div class="detail-main">
        <div class="detail-main-title">{{RowId}}</div>
        <div class="main-text">
          <!--<div v-html="description">
                        {{description}}
          </div>-->
          <div v-if="RowId =='中华人民共和国担保法'">
             <div class="Section0" style="layout-grid:15.6000pt;">
                  <p>
                    <h1 align="center" style="text-align:center;">
                      <b><span>中华人民共和国担保法</span></b><b></b>
                    </h1>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>《中华人民共和国担保法》已由中华人民共和国第八届</span><a href="https://baike.baidu.com/item/%E5%85%A8%E5%9B%BD%E4%BA%BA%E6%B0%91%E4%BB%A3%E8%A1%A8%E5%A4%A7%E4%BC%9A%E5%B8%B8%E5%8A%A1%E5%A7%94%E5%91%98%E4%BC%9A"><u><span>全国人民代表大会常务委员会</span></u></a><span>第十四次会议于</span><span>1995</span><span>年</span><span>6</span><span>月</span><span>30</span><span>日通过，现予公布，自</span><span>1995</span><span>年</span><span>10</span><span>月</span><span>1</span><span>日起施行。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（</span><span>1995</span><span>年</span><span>6</span><span>月</span><span>30</span><span>日第八届全国人民代表大会常务委员会第十四次会议通过）</span>
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="1_2"></a><a name="目录"></a><a name="sub70632_1_2"></a><a name="1-2"></a><span>目录</span>
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第一章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%80%BB%E5%88%99"><u><span>总则</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二章</span> 保证
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第一节</span> 保证和<a href="https://baike.baidu.com/item/%E4%BF%9D%E8%AF%81%E4%BA%BA"><u><span>保证人</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二节</span> 保证合同和保证方式
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三节</span> 保证<a href="https://baike.baidu.com/item/%E8%B4%A3%E4%BB%BB"><u><span>责任</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%8A%B5%E6%8A%BC"><u><span>抵押</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第一节</span> 抵押和<a href="https://baike.baidu.com/item/%E6%8A%B5%E6%8A%BC%E7%89%A9"><u><span>抵押物</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二节</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%8A%B5%E6%8A%BC%E5%90%88%E5%90%8C"><u><span>抵押合同</span></u></a><span>和抵押物登记</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三节</span> 抵押的效力
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四节</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%8A%B5%E6%8A%BC%E6%9D%83"><u><span>抵押权</span></u></a><span>的实现</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五节</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%9C%80%E9%AB%98%E9%A2%9D%E6%8A%B5%E6%8A%BC"><u><span>最高额抵押</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E8%B4%A8%E6%8A%BC"><u><span>质押</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第一节</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E5%8A%A8%E4%BA%A7"><u><span>动产</span></u></a><span>质押</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二节</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%9D%83%E5%88%A9%E8%B4%A8%E6%8A%BC"><u><span>权利质押</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E7%95%99%E7%BD%AE"><u><span>留置</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E5%AE%9A%E9%87%91"><u><span>定金</span></u></a>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七章</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E9%99%84%E5%88%99"><u><span>附则</span></u></a>
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="第一章_总则"></a><a name="sub70632_1_3"></a><a name="1_3"></a><a name="1-3"></a><span>第一章</span> 总则
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第一条</span> 为促进资金融通和商品流通，保障<a href="https://baike.baidu.com/item/%E5%80%BA%E6%9D%83"><u><span>债权</span></u></a><span>的实现，发展</span><a href="https://baike.baidu.com/item/%E7%A4%BE%E4%BC%9A%E4%B8%BB%E4%B9%89%E5%B8%82%E5%9C%BA%E7%BB%8F%E6%B5%8E"><u><span>社会主义市场经济</span></u></a><span>，制定本法。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二条</span> 在<a href="https://baike.baidu.com/item/%E5%80%9F%E8%B4%B7/79595"><u><span>借贷</span></u></a><span>、买卖、货物运输、加工</span><a href="https://baike.baidu.com/item/%E6%89%BF%E6%8F%BD"><u><span>承揽</span></u></a><span>等经济活动中，债权人需要以担保方式保障其债权实现的，可以依照本法规定设定担保。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>本法规定的担保方式为保证、抵押、质押、留置和定金。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三条</span> 担保活动应当遵循平等、自愿、公平、诚实信用的<a href="https://baike.baidu.com/item/%E5%8E%9F%E5%88%99"><u><span>原则</span></u></a><span>。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四条</span> 第三人为债务人向债权人提供担保时，可以要求债务人提供<a href="https://baike.baidu.com/item/%E5%8F%8D%E6%8B%85%E4%BF%9D"><u><span>反担保</span></u></a><span>。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>反担保适用本法担保的规定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五条</span> 担保合同是<a href="https://baike.baidu.com/item/%E4%B8%BB%E5%90%88%E5%90%8C"><u><span>主合同</span></u></a><span>的从合同，主合同无效，</span><a href="https://baike.baidu.com/item/%E6%8B%85%E4%BF%9D%E5%90%88%E5%90%8C%E6%97%A0%E6%95%88"><u><span>担保合同无效</span></u></a><span>。担保合同另有约定的，按照约定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>担保合同被确认无效后，债务人、担保人、债权人有过错的，应当根据其过错各自承担相应的</span><a href="https://baike.baidu.com/item/%E6%B0%91%E4%BA%8B%E8%B4%A3%E4%BB%BB"><u><span>民事责任</span></u></a><span>。</span>
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="1_4"></a><a name="1-4"></a><a name="sub70632_1_4"></a><a name="第二章_保证"></a><span>第二章</span> 保证
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第一节</span> 保证和保证人</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六条</span> 本法所称保证，是指保证人和债权人约定，当债务人不履行债务时，保证人按照约定履行债务或者承担责任的行为。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七条</span> 具有代为清偿债务能力的法人、其他组织或者公民，可以作保证人。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八条</span> 国家机关不得为保证人，但经国务院批准为使用外国政府或者<a href="https://baike.baidu.com/item/%E5%9B%BD%E9%99%85%E7%BB%8F%E6%B5%8E%E7%BB%84%E7%BB%87"><u><span>国际经济组织</span></u></a><span>贷款进行转贷的除外。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九条</span> 学校、幼儿园、医院等以公益为目的的事业单位、社会团体不得为保证人。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十条</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E4%BC%81%E4%B8%9A%E6%B3%95%E4%BA%BA"><u><span>企业法人</span></u></a><span>的</span><a href="https://baike.baidu.com/item/%E5%88%86%E6%94%AF%E6%9C%BA%E6%9E%84"><u><span>分支机构</span></u></a><span>、职能部门不得为保证人。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>企业法人的分支机构有法人书面授权的，可以在授权范围内提供保证。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十一条</span> 任何单位和个人不得强令银行等<a href="https://baike.baidu.com/item/%E9%87%91%E8%9E%8D%E6%9C%BA%E6%9E%84"><u><span>金融机构</span></u></a><span>或者企业为他人提供保证；银行等金融机构或者企业对强令其为他人提供保证的行为，有权拒绝。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十二条</span> 同一债务有两个以上保证人的，保证人应当按照保证合同约定的保证份额，承担保证责任。没有约定保证份额的，保证人<a href="https://baike.baidu.com/item/%E6%89%BF%E6%8B%85%E8%BF%9E%E5%B8%A6%E8%B4%A3%E4%BB%BB"><u><span>承担连带责任</span></u></a><span>，债权人可以要求任何一个保证人承担全部保证责任，保证人都负有担保全部债权实现的</span><a href="https://baike.baidu.com/item/%E4%B9%89%E5%8A%A1"><u><span>义务</span></u></a><span>。已经承担保证责任的保证人，有权向债务人追偿，或者要求承担连带责任的其他保证人清偿其应当承担的份额。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第二节</span> 保证合同和保证方式</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十三条</span> 保证人与债权人应当以书面形式订立<a href="https://baike.baidu.com/item/%E4%BF%9D%E8%AF%81%E5%90%88%E5%90%8C"><u><span>保证合同</span></u></a><span>。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十四条</span> 保证人与债权人可以就单个主合同分别订立保证合同，也可以协议在最高债权额限度内就一定期间连续发生的借款合同或者某项商品交易<a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E8%AE%A2%E7%AB%8B"><u><span>合同订立</span></u></a><span>一个保证合同。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十五条</span> 保证合同应当包括以下内容：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）被保证的主债权种类、数额；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）债务人履行债务的期限；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）保证的方式；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）保证担保的范围；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）保证的期间；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（六）双方认为需要约定的其他事项。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>保证合同不完全具备前款规定内容的，可以补正。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十六条</span> 保证的方式有：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）</span><a href="https://baike.baidu.com/item/%E4%B8%80%E8%88%AC%E4%BF%9D%E8%AF%81"><u><span>一般保证</span></u></a><span>；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）</span><a href="https://baike.baidu.com/item/%E8%BF%9E%E5%B8%A6%E8%B4%A3%E4%BB%BB%E4%BF%9D%E8%AF%81"><u><span>连带责任保证</span></u></a><span>。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十七条</span> 当事人在保证合同中约定，债务人不能履行债务时，由保证人承担保证责任的，为一般保证。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>一般保证的保证人在主合同纠纷未经审判或者仲裁，并就</span><a href="https://baike.baidu.com/item/%E5%80%BA%E5%8A%A1%E4%BA%BA%E8%B4%A2%E4%BA%A7"><u><span>债务人财产</span></u></a><span>依法强制执行仍不能履行债务前，对债权人可以拒绝承担保证责任。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>有下列情形之一的，保证人不得行使前款规定的权利：</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）债务人住所变更，致使债权人要求其履行债务发生重大困难的；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）</span><a href="https://baike.baidu.com/item/%E4%BA%BA%E6%B0%91%E6%B3%95%E9%99%A2"><u><span>人民法院</span></u></a><span>受理债务人破产案件，中止执行程序的；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）保证人以书面形式放弃前款规定的权利的。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十八条</span> 当事人在保证合同中约定保证人与债务人对债务承担连带责任的，为连带责任保证。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>连带责任保证的债务人在主合同规定的债务履行期届满没有履行债务的，债权人可以要求债务人履行债务，也可以要求保证人在其保证范围内承担保证责任。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第十九条</span> 当事人对保证方式没有约定或者约定不明确的，按照连带责任保证承担保证责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十条</span> 一般保证和连带责任保证的保证人享有债务人的抗辩权。债务人放弃对债务的抗辩权的，保证人仍有权抗辩。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抗辩权是指债权人行使债权时，债务人根据法定事由，对抗债权人行使请求权的权利。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第三节</span> 保证责任</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十一条</span> 保证担保的范围包括主债权及利息、<a href="https://baike.baidu.com/item/%E8%BF%9D%E7%BA%A6%E9%87%91"><u><span>违约金</span></u></a><span>、损害赔偿金和实现债权的费用。保证合同另有约定的，按照约定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>当事人对保证担保的范围没有约定或者约定不明确的，保证人应当对全部债务承担责任。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十二条</span> 保证期间，债权人依法将主债权转让给第三人的，保证人在原保证担保的范围内继续承担保证责任。保证合同另有约定的，按照约定。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十三条</span> 保证期间，债权人许可债务人转让债务的，应当取得保证人书面同意，保证人对未经其同意转让的债务，不再承担保证责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十四条</span> 债权人与债务人协议变更主合同的，应当取得保证人书面同意，未经保证人书面同意的，保证人不再承担保证责任。保证合同另有约定的，按照约定。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十五条</span> 一般保证的保证人与债权人未约定保证期间的，保证期间为主债务履行期届满之日起六个月。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>在合同约定的保证期间和前款规定的保证期间，债权人未对债务人提起诉讼或者申请仲裁的，保证人免除保证责任；债权人已提起诉讼或者申请仲裁的，保证期间适用</span><a href="https://baike.baidu.com/item/%E8%AF%89%E8%AE%BC%E6%97%B6%E6%95%88%E4%B8%AD%E6%96%AD"><u><span>诉讼时效中断</span></u></a><span>的规定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十六条</span> 连带责任保证的保证人与债权人未约定保证期间的，债权人有权自主债务履行期届满之日起六个月内要求保证人承担保证责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>在合同约定的保证期间和前款规定的保证期间，债权人未要求保证人承担保证责任的，保证人免除保证责任。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十七条</span> 保证人依照本法第十四条规定就连续发生的债权作保证，未约定保证期间的，保证人可以随时书面通知债权人终止保证合同，但保证人对于通知到债权人前所发生的债权，承担保证责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十八条</span> 同一债权既有保证又有物的担保的，保证人对物的担保以外的债权承担保证责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>债权人放弃物的担保的，保证人在债权人放弃权利的范围内免除保证责任。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第二十九条</span> 企业法人的分支机构未经法人书面授权或者超出授权范围与债权人订立保证合同的，该合同无效或者超出授权范围的部分无效，债权人和企业法人有过错的，应当根据其过错各自承担相应的民事责任；债权人无过错的，由企业法人承担民事责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十条</span> 有下列情形之一的，保证人不承担民事责任：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）主合同当事人双方串通，骗取保证人提供保证的；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）主合同债权人采取欺诈、胁迫等手段，使保证人在违背真实意思的情况下提供保证的。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十一条</span> 保证人承担保证责任后，有权向债务人追偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十二条</span> 人民法院受理债务人破产案件后，债权人未申报债权的，保证人可以参加破产财产分配，预先行使追偿权。
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="sub70632_1_5"></a><a name="1_5"></a><a name="1-5"></a><a name="第三章_抵押"></a><span>第三章</span> 抵押
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第一节</span> 抵押和抵押物</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十三条</span> 本法所称抵押，是指债务人或者第三人不转移对本法第三十四条所列财产的占有，将该财产作为债权的担保。债务人不履行债务时，债权人有权依照本法规定以该财产折价或者以拍卖、变卖该财产的价款优先受偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>前款规定的债务人或者第三人为抵押人，债权人为抵押权人，提供担保的财产为抵押物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十四条</span> 下列财产可以抵押：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）抵押人所有的房屋和其他地上定着物；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）抵押人所有的机器、交通运输工具和其他财产；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）抵押人依法有权处分的国有的土地使用权、房屋和其他地上定着物；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）抵押人依法有权处分的国有的机器、交通运输工具和其他财产；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）抵押人依法承包并经发包方同意抵押的荒山、荒沟、荒丘、荒滩等荒地的土地使用权；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（六）依法可以抵押的其他财产。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抵押人可以将前款所列财产一并抵押。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十五条</span> 抵押人所担保的债权不得超出其抵押物的价值。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>财产抵押后，该财产的价值大于所担保债权的余额部分，可以再次抵押，但不得超出其余额部分。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十六条</span> 以依法取得的国有土地上的房屋抵押的，该房屋占用范围内的<a href="https://baike.baidu.com/item/%E5%9B%BD%E6%9C%89%E5%9C%9F%E5%9C%B0%E4%BD%BF%E7%94%A8%E6%9D%83"><u><span>国有土地使用权</span></u></a><span>同时抵押。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>以出让方式取得的国有土地使用权抵押的，应当将抵押时该国有土地上的房屋同时抵押。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>乡（镇）、村企业的土地使用权不得单独抵押。以乡（镇）、村企业的厂房等建筑物抵押的，其占用范围内的土地使用权同时抵押。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十七条</span> 下列财产不得抵押：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）土地所有权：</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）耕地、宅基地、自留地、自留山等集体所有的土地使用权，但本法第三十四条第（五）项、第三十六条第三款规定的除外；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）学校、幼儿园、医院等以公益为目的的事业单位、社会团体的教育设施、医疗卫生设施和其他社会公益设施；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）所有权、使用权不明或者有争议的财产；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）依法被查封、扣押、监管的财产；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（六）依法不得抵押的其他财产。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第二节</span> 抵押合同和抵押物登记</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十八条</span> 抵押人和抵押权人应当以书面形式订立抵押合同。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第三十九条</span> 抵押合同应当包括以下内容：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）被担保的主债权种类、数额；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）债务人履行债务的期限；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）抵押物的名称、数量、质量、状况、所在地、所有权权属或者使用权权属；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）抵押担保的范围；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）当事人认为需要约定的其他事项。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抵押合同不完全具备前款规定内容的，可以补正。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十条</span> 订立抵押合同时，抵押权人和抵押人在合同中不得约定在债务履行期届满抵押权人未受清偿时，抵押物的所有权转移为债权人所有。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十一条</span> 当事人以本法第四十二条规定的财产抵押的，应当办理抵押物登记，抵押合同自登记之日起生效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十二条</span> 办理抵押物登记的部门如下：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）以无地上定着物的</span><a href="https://baike.baidu.com/item/%E5%9C%9F%E5%9C%B0%E4%BD%BF%E7%94%A8%E6%9D%83%E6%8A%B5%E6%8A%BC"><u><span>土地使用权抵押</span></u></a><span>的，为核发土地使用权证书的</span><a href="https://baike.baidu.com/item/%E5%9C%9F%E5%9C%B0%E7%AE%A1%E7%90%86%E9%83%A8%E9%97%A8"><u><span>土地管理部门</span></u></a><span>；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）以城市房地产或者乡（镇）、村企业的厂房等建筑物抵押的，为县级以上地方人民政府规定的部门；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）以林木抵押的，为县级以上林木主管部门；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）以航空器、船舶、车辆抵押的，为运输工具的登记部门；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）以企业的设备和其他动产抵押的，为财产所在地的工商行政管理部门。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十三条</span> 当事人以其他财产抵押的，可以自愿办理抵押物登记，抵押合同自签订之日起生效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>当事人未办理抵押物登记的，</span><a href="https://baike.baidu.com/item/%E4%B8%8D%E5%BE%97%E5%AF%B9%E6%8A%97%E7%AC%AC%E4%B8%89%E4%BA%BA"><u><span>不得对抗第三人</span></u></a><span>。当事人办理抵押物登记的，登记部门为抵押人所在地的公证部门。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十四条</span> 办理抵押物登记，应当向登记部门提供下列文件或者其复印件：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）主合同和抵押合同；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）抵押物的所有权或者使用权证书。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十五条</span> 登记部门登记的资料，应当允许查阅、抄录或者复印。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第三节</span> 抵押的效力</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十六条</span> 抵押担保的范围包括主债权及利息、违约金、损害赔偿金和实现抵押权的费用。抵押合同另有约定的，按照约定。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十七条</span> 债务履行期届满，债务人不履行债务致使抵押物被人民法院依法扣押的，自扣押之日起抵押权人有权收取由抵押物分离的<a href="https://baike.baidu.com/item/%E5%A4%A9%E7%84%B6%E5%AD%B3%E6%81%AF"><u><span>天然孳息</span></u></a><span>以及抵押人就抵押物可以收取的</span><a href="https://baike.baidu.com/item/%E6%B3%95%E5%AE%9A%E5%AD%B3%E6%81%AF"><u><span>法定孳息</span></u></a><span>。抵押权人未将扣押抵押物的事实通知应当清偿法定孳息的义务人的，抵押权的效力不及于该孳息。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>前款孳息应当先充抵收取孳息的费用。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十八条</span> 抵押人将已出租的财产抵押的，应当书面告知承租人，原租赁合同继续有效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第四十九条</span> 抵押期间，抵押人转让已办理登记的抵押物的，应当通知抵押权人并告知受让人转让物已经抵押的情况；抵押人未通知抵押权人或者未告知受让人的，转让行为无效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>转让抵押物的价款明显低于其价值的，抵押权人可以要求抵押人提供相应的担保；抵押人不提供的，不得转让抵押物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抵押人转让抵押物所得的价款，应当向抵押权人提前清偿所担保的债权或者向与抵押权人约定的第三人</span><a href="https://baike.baidu.com/item/%E6%8F%90%E5%AD%98"><u><span>提存</span></u></a><span>。超过债权数额的部分，归抵押人所有，不足部分由债务人清偿。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十条</span> 抵押权不得与债权分离而单独转让或者作为其他债权的担保。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十一条</span> 抵押人的行为足以使抵押物价值减少的，抵押权人有权要求抵押人停止其行为。抵押物价值减少时，抵押权人有权要求抵押人恢复抵押物的价值，或者提供与减少的价值相当的担保。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抵押人对抵押物价值减少无过错的，抵押权人只能在抵押人因损害而得到的赔偿范围内要求提供担保。抵押物价值未减少的部分，仍作为债权的担保。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十二条</span> 抵押权与其担保的债权同时存在，债权消灭的，抵押权也消灭。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第四节</span> 抵押权的实现</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十三条</span> 债务履行期届满抵押权人未受清偿的，可以与抵押人协议以抵押物折价或者以拍卖、变卖该抵押物所得的价款受偿；协议不成的，抵押权人可以向人民法院提起诉讼。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>抵押物折价或者拍卖、变卖后，其价款超过债权数额的部分归抵押人所有，不足部分由债务人清偿。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十四条</span> 同一财产向两个以上债权人抵押的，拍卖、变卖抵押物所得的价款按照以下规定清偿：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）抵押合同以登记生效的，按照抵押物登记的先后顺序清偿；顺序相同的，按照债权比例清偿；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）抵押合同自签订之日起生效的，该抵押物已登记的，按照本条第（一）项规定清偿；未登记的，按照</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E7%94%9F%E6%95%88"><u><span>合同生效</span></u></a><span>时间的先后顺序清偿，顺序相同的，按照债权比例清偿。抵押物已登记的先于未登记的受偿。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十五条</span> 城市房地产抵押合同签订后，土地上新增的房屋不属于抵押物。需要拍卖该抵押的房地产时，可以依法将该土地上新增的房屋与抵押物一同拍卖，但对拍卖新增房屋所得，抵押权人无权优先受偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>依照本法规定以承包的荒地的土地使用权抵押的，或者以乡（镇）、村企业的厂房等建筑物占用范围内的土地使用权抵押的，在实现抵押权后，未经法定程序不得改变土地集体所有和土地用途。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十六条</span> 拍卖划拨的国有土地使用权所得的价款，在依法缴纳相当于应缴纳的<a href="https://baike.baidu.com/item/%E5%9C%9F%E5%9C%B0%E4%BD%BF%E7%94%A8%E6%9D%83%E5%87%BA%E8%AE%A9%E9%87%91"><u><span>土地使用权出让金</span></u></a><span>的款额后，抵押权人有优先受偿权。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十七条</span> 为债务人抵押担保的第三人，在抵押权人实现抵押权后，有权向债务人追偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十八条</span> 抵押权因抵押物灭失而消灭。因灭失所得的赔偿金，应当作为抵押财产。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第五节</span> 最高额抵押</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第五十九条</span> 本法所称最高额抵押，是指抵押人与抵押权人协议，在最高债权额限度内，以抵押物对一定期间内连续发生的债作担保。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十条</span> 借款合同可以附最高额抵押合同。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>债权人与债务人就某项商品在一定期间内连续发生交易而签订的合同，可以附最高额抵押合同。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十一条</span> 最高额抵押的主合同债权不得转让。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十二条</span> 最高额抵押除适用本节规定外，适用本章其他规定。
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="1_6"></a><a name="sub70632_1_6"></a><a name="1-6"></a><a name="第四章_质押"></a><span>第四章</span> 质押
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第一节</span> 动产质押</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十三条</span> 本法所称动产质押，是指债务人或者第三人将其动产移交债权人占有，将该动产作为债权的担保。债务人不履行债务时，债权人有权依照本法规定以该动产折价或者以拍卖、变卖该动产的价款优先受偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>前款规定的债务人或者第三人为</span><a href="https://baike.baidu.com/item/%E5%87%BA%E8%B4%A8"><u><span>出质</span></u></a><span>人，债权人为质权人，移交的动产为质物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十四条</span> 出质人和质权人应当以书面形式订立<a href="https://baike.baidu.com/item/%E8%B4%A8%E6%8A%BC%E5%90%88%E5%90%8C"><u><span>质押合同</span></u></a><span>。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>质押合同自质物移交于质权人占有时生效。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十五条</span> 质押合同应当包括以下内容：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）被担保的主债权种类、数额；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）债务人履行债务的期限；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）质物的名称、数量、质量、状况；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）质押担保的范围；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（五）质物移交的时间；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（六）当事人认为需要约定的其他事项。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>质押合同不完全具备前款规定内容的，可以补正。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十六条</span> 出质人和质权人在合同中不得约定在债务履行期届满质权人未受清偿时，质物的所有权转移为质权人所有。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十七条</span> 质押担保的范围包括主债权及利息、违约金、损害赔偿金、质物保管费用和实现质权的费用。质押合同另有约定的，按照约定。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十八条</span> 质权人有权收取质物所生的孳息。质押合同另有约定的，按照约定。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>前款孳息应当先充抵收取孳息的费用。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第六十九条</span> 质权人负有妥善保管质物的义务。因保管不善致使质物灭失或者毁损的，质权人应当承担民事责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>质权人不能妥善保管质物可能致使其灭失或者毁损的，出质人可以要求质权人将质物提存，或者要求提前清偿债权而返还质物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十条</span> 质物有损坏或者价值明显减少的可能，足以危害质权人权利的，质权人可以要求出质人提供相应的担保。出质人不提供的，质权人可以拍卖或者变卖质物，并与出质人协议将拍卖或者变卖所得的价款用于提前清偿所担保的债权或者向与出质人约定的第三人提存。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十一条</span> 债务履行期届满债务人履行债务的，或者出质人提前清偿所担保的债权的，质权人应当返还质物。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>债务履行期届满质权人未受清偿的，可以与出质人协议以质物折价，也可以依法拍卖、变卖质物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>质物折价或者拍卖、变卖后，其价款超过债权数额的部分归出质人所有，不足部分由债务人清偿。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十二条</span> 为债务人质押担保的第三人，在质权人实现质权后，有权向债务人追偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十三条</span> 质权因质物灭失而消灭。因灭失所得的赔偿金，应当作为出质财产。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十四条</span> 质权与其担保的债权同时存在，债权消灭的，质权也消灭。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <b><span>第二节</span> 权利质押</b>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十五条</span> 下列权利可以质押：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）</span><a href="https://baike.baidu.com/item/%E6%B1%87%E7%A5%A8"><u><span>汇票</span></u></a><span>、支票、本票、</span><a href="https://baike.baidu.com/item/%E5%80%BA%E5%88%B8"><u><span>债券</span></u></a><span>、</span><a href="https://baike.baidu.com/item/%E5%AD%98%E6%AC%BE%E5%8D%95"><u><span>存款单</span></u></a><span>、</span><a href="https://baike.baidu.com/item/%E4%BB%93%E5%8D%95"><u><span>仓单</span></u></a><span>、提单；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）依法可以转让的股份、</span><a href="https://baike.baidu.com/item/%E8%82%A1%E7%A5%A8"><u><span>股票</span></u></a><span>；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（三）依法可以转让的商标专用权，</span><a href="https://baike.baidu.com/item/%E4%B8%93%E5%88%A9%E6%9D%83"><u><span>专利权</span></u></a><span>、著作权中的</span><a href="https://baike.baidu.com/item/%E8%B4%A2%E4%BA%A7%E6%9D%83"><u><span>财产权</span></u></a><span>；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（四）依法可以质押的其他权利。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十六条</span> 以汇票、支票、本票、债券、存款单、仓单、提单出质的，应当在合同约定的期限内将权利凭证交付质权人。质押合同自权利凭证交付之日起生效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十七条</span> 以载明兑现或者提货日期的汇票、支票、本票、债券、存款单、仓单、提单出质的，汇票、支票、本票、债券、存款单、仓单、提单兑现或者提货日期先于债务履行期的，质权人可以在债务履行期届满前兑现或者提货，并与出质人协议将兑现的价款或者提取的货物用于提前清偿所担保的债权或者向与出质人约定的第三人提存。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十八条</span> 以依法可以转让的股票出质的，出质人与质权人应当订立书面合同，并向<a href="https://baike.baidu.com/item/%E8%AF%81%E5%88%B8%E7%99%BB%E8%AE%B0"><u><span>证券登记</span></u></a><span>机构办理出质登记。质押合同自登记之日起生效。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>股票出质后，不得转让，但经出质人与质权人协商同意的可以转让。出质人转让股票所得的价款应当向质权人提前清偿所担保的债权或者向与质权人约定的第三人提存。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>以有限责任公司的股份出质的，适用公司法股份转让的有关规定。质押合同自股份出质记载于股东名册之日起生效。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第七十九条</span> 以依法可以转让的商标专用权，专利权、著作权中的财产权出质的，出质人与质权人应当订立书面合同，并向其管理部门办理出质登记。质押合同自登记之日起生效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十条</span> 本法第七十九条规定的权利出质后，出质人不得转让或者许可他人使用，但经出质人与质权人协商同意的可以转让或者许可他人使用。出质人所得的转让费、许可费应当向质权人提前清偿所担保的债权或者向与质权人约定的第三人提存。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十一条</span> 权利质押除适用本节规定外，适用本章第一节的规定。
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="1_7"></a><a name="sub70632_1_7"></a><a name="第五章_留置"></a><a name="1-7"></a><span>第五章</span> 留置
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十二条</span> 本法所称留置，是指依照本法第八十四条的规定，债权人按照合同约定占有债务人的动产，债务人不按照合同约定的期限履行债务的，债权人有权依照本法规定留置该财产，以该财产折价或者以拍卖、变卖该财产的价款优先受偿。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十三条</span> 留置担保的范围包括主债权及利息、违约金、损害赔偿金，留置物保管费用和实现<a href="https://baike.baidu.com/item/%E7%95%99%E7%BD%AE%E6%9D%83"><u><span>留置权</span></u></a><span>的费用。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十四条</span> 因保管合同、运输合同、<a href="https://baike.baidu.com/item/%E5%8A%A0%E5%B7%A5%E6%89%BF%E6%8F%BD%E5%90%88%E5%90%8C"><u><span>加工承揽合同</span></u></a><span>发生的债权，债务人不履行债务的，债权人有留置权。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>法律规定可以留置的其他合同，适用前款规定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>当事人可以在合同中约定不得留置的物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十五条</span> 留置的财产为可分物的，留置物的价值应当相当于债务的金额。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十六条</span> 留置权人负有妥善保管留置物的义务。因保管不善致使留置物灭失或者毁损的，留置权人应当承担民事责任。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十七条</span> 债权人与债务人应当在合同中约定，债权人留置财产后，债务人应当在不少于两个月的期限内履行债务。债权人与债务人在合同中未约定的，债权人留置债务人财产后，应当确定两个月以上的期限，通知债务人在该期限内履行债务。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>债务人逾期仍不履行的，债权人可以与债务人协议以留置物折价，也可以依法拍卖、变卖留置物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>留置物折价或者拍卖、变卖后，其价款超过债权数额的部分归债务人所有，不足部分由债务人清偿。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十八条</span> 留置权因下列原因消灭：
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（一）债权消灭的；</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>（二）债务人另行提供担保并被债权人接受的。</span>
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="sub70632_1_8"></a><a name="1_8"></a><a name="1-8"></a><a name="第六章_定金"></a><span>第六章</span> 定金
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第八十九条</span> 当事人可以约定一方向对方给付定金作为债权的担保。债务人履行债务后，定金应当抵作价款或者收回。给付定金的一方不履行约定的债务的，无权要求返还定金；收受定金的一方不履行约定的债务的，应当双倍返还定金。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十条</span> 定金应当以书面形式约定。当事人在定金合同中应当约定交付定金的期限。定金合同从实际交付定金之日起生效。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十一条</span> 定金的数额由当事人约定，但不得超过主合同标的额的百分之二十。
                    </p>
                    <h3 style="background:#FFFFFF;">
                      <a name="第七章_附则"></a><a name="1-9"></a><a name="1_9"></a><a name="sub70632_1_9"></a><span>第七章</span> 附则
                    </h3>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十二条</span> 本法所称不动产是指土地以及房屋、林木等地上定着物。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>本法所称动产是指不动产以外的物。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十三条</span> 本法所称保证合同、抵押合同、质押合同、定金合同可以是单独订立的书面合同，包括当事人之间的具有担保性质的信函、传真等，也可以是主合同中的担保条款。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十四条</span> 抵押物、质物、留置物折价或者变卖，应当参照市场价格。
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十五条</span><span>&nbsp;</span><a href="https://baike.baidu.com/item/%E6%B5%B7%E5%95%86%E6%B3%95"><u><span>海商法</span></u></a><span>等法律对担保有特别规定的，依照其规定。</span>
                    </p>
                    <p class="MsoNormal" style="text-indent:24.0000pt;background:#FFFFFF;">
                      <span>第九十六条</span> 本法自<span>1995</span><span>年</span><span>10</span><span>月</span><span>1</span><span>日起施行。</span>
                    </p>
                    <p class="MsoNormal">
                      &nbsp;
                    </p>
                  <p>
                    <br />
                  </p>
             </div>
          </div>
          <div v-if="RowId =='中华人民共和国合同法'">
              <div class="Section0" style="layout-grid:15.6000pt;">
                  <p>
	<br />
</p>
<h1 align="center" style="text-align:center;">
	<b><span>
	<h1 align="center" style="text-align:center;">
		<b><span>中华人民共和国合同法</span></b><b></b>
	</h1>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第一章&emsp;一般规定</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一条&emsp;为了保护合同当事人的</span><a href="https://baike.baidu.com/item/%E5%90%88%E6%B3%95%E6%9D%83%E7%9B%8A"><u><span>合法权益</span></u></a><span>，维护社会经济秩序，促进社会主义现代化建设，制定本法。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二条&emsp;本法所称合同是平等主体的自然人、法人、其他组织之间设立、变更、终止民事权利义务关系的协议。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>婚姻、收养、监护等有关身份关系的协议，适用其他法律的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三条&emsp;合同当事人的法律地位平等，一方不得将自己的意志强加给另一方。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四条&emsp;当事人依法享有自愿订立合同的权利，任何单位和个人不得非法干预。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五条&emsp;当事人应当遵循公平原则确定各方的权利和义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六条&emsp;当事人行使权利、履行义务应当遵循</span><a href="https://baike.baidu.com/item/%E8%AF%9A%E5%AE%9E%E4%BF%A1%E7%94%A8%E5%8E%9F%E5%88%99"><u><span>诚实信用原则</span></u></a><span>。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七条&emsp;当事人订立、履行合同，应当遵守法律、行政法规，尊重社会公德，不得扰乱社会经济秩序，损害社会公共利益。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八条&emsp;依法成立的合同，对当事人具有法律约束力。当事人应当按照约定履行自己的义务，不得擅自变更或者解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>依法成立的合同，受法律保护。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二章&emsp;合同的订立</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九条&emsp;当事人订立合同，应当具有相应的民事权利能力和民事行为能力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人依法可以委托代理人订立合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十条&emsp;当事人订立合同，有书面形式、口头形式和其他形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律、行政法规规定采用书面形式的，应当采用书面形式。当事人约定采用书面形式的，应当采用书面形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十一条&emsp;书面形式是指合同书、信件和数据电文（包括</span><a href="https://baike.baidu.com/item/%E7%94%B5%E6%8A%A5"><u><span>电报</span></u></a><span>、电传、传真、电子数据交换和</span><a href="https://baike.baidu.com/item/%E7%94%B5%E5%AD%90%E9%82%AE%E4%BB%B6"><u><span>电子邮件</span></u></a><span>）等可以有形地表现所载内容的形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十二条&emsp;合同的内容由当事人约定，一般包括以下条款：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）当事人的名称或者姓名和</span><a href="https://baike.baidu.com/item/%E4%BD%8F%E6%89%80"><u><span>住所</span></u></a><span>；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）标的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）数量；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）质量；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）价款或者</span><a href="https://baike.baidu.com/item/%E6%8A%A5%E9%85%AC"><u><span>报酬</span></u></a><span>；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（六）履行期限、地点和方式；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（七）违约责任；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（八）解决争议的方法。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人可以参照各类合同的示范文本订立合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十三条&emsp;</span> 当事人订立合同，采取要约、承诺方式。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十四条&emsp;要约是希望和他人订立合同的意思表示，该意思表示应当符合下列规定：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）内容具体确定；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）表明经受要约人承诺，要约人即受该意思表示约束。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十五条&emsp;要约邀请是希望他人向自己发出要约的意思表示。寄送的价目表、拍卖公告、</span><a href="https://baike.baidu.com/item/%E6%8B%9B%E6%A0%87%E5%85%AC%E5%91%8A"><u><span>招标公告</span></u></a><span>、招股说明书、商业广告等为要约邀请。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>商业广告的内容符合要约规定的，视为要约。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十六条&emsp;要约到达受要约人时生效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>采用数据电文形式订立合同，收件人指定特定系统接收数据电文的，该数据电文进入该特定系统的时间，视为到达时间；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>未指定特定系统的，该数据电文进入收件人的任何系统的首次时间，视为到达时间。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十七条&emsp;要约可以撤回。撤回要约的通知应当在要约到达受要约人之前或者与要约同时到达受要约人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十八条&emsp;要约可以撤销。撤销要约的通知应当在受要约人发出承诺通知之前到达受要约人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第十九条&emsp;有下列情形之一的，要约不得撤销：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）要约人确定了承诺期限或者以其他形式明示要约不可撤销；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）受要约人有理由认为要约是不可撤销的，并已经为履行合同作了准备工作。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十条&emsp;有下列情形之一的，要约失效：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）拒绝要约的通知到达要约人；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）要约人依法撤销要约；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）承诺期限届满，受要约人未作出承诺；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）受要约人对要约的内容作出实质性变更。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十一条&emsp;</span> 承诺是受要约人同意要约的意思表示。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十二条&emsp;承诺应当以通知的方式作出，但根据交易习惯或者要约表明可以通过行为作出承诺的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十三条&emsp;承诺应当在要约确定的期限内到达要约人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>要约没有确定承诺期限的，承诺应当依照下列规定到达：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）要约以对话方式作出的，应当即时作出承诺，但当事人另有约定的除外；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）要约以非对话方式作出的，承诺应当在合理期限内到达。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十四条&emsp;要约以信件或者电报作出的，承诺期限自信件载明的日期或者电报交发之日开始计算。信件未载明日期的，自投寄该信件的邮戳日期开始计算。要约以电话、传真等快速通讯方式作出的，承诺期限自要约到达受要约人时开始计算。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十五条&emsp;</span> 承诺生效时合同成立。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十六条&emsp;</span> 承诺通知到达要约人时生效。承诺不需要通知的，根据交易习惯或者要约的要求作出承诺的行为时生效。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>采用数据电文形式订立合同的，承诺到达的时间适用本法第十六条第二款的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十七条&emsp;承诺可以撤回。撤回承诺的通知应当在承诺通知到达要约人之前或者与承诺通知同时到达要约人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十八条&emsp;受要约人超过承诺期限发出承诺的，除要约人及时通知受要约人该承诺有效的以外，为新要约。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二十九条&emsp;受要约人在承诺期限内发出承诺，按照通常情形能够及时到达要约人，但因其他</span><a href="https://baike.baidu.com/item/%E5%8E%9F%E5%9B%A0"><u><span>原因</span></u></a><span>承诺到达要约人时超过承诺期限的，除要约人及时通知受要约人因承诺超过期限不接受该承诺的以外，该承诺有效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十条&emsp;承诺的内容应当与要约的内容一致。受要约人对要约的内容作出实质性变更的，为新要约。有关</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E6%A0%87%E7%9A%84"><u><span>合同标的</span></u></a><span>、数量、质量、价款或者报酬、履行期限、履行地点和方式、违约责任和解决争议方法等的变更，是对要约内容的实质性变更。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十一条&emsp;承诺对要约的内容作出非实质性变更的，除要约人及时表示反对或者要约表明承诺不得对要约的内容作出任何变更的以外，该承诺有效，合同的内容以承诺的内容为准。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十二条&emsp;当事人采用合同书形式订立合同的，自双方当事人签字或者盖章时合同成立。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十三条&emsp;当事人采用信件、数据电文等形式订立合同的，可以在合同成立之前要求签订确认书。签订确认书时合同成立。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十四条&emsp;承诺生效的地点为合同成立的地点。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>采用数据电文形式订立合同的，收件人的主营业地为合同成立的地点；没有主营业地的，其经常居住地为合同成立的地点。当事人另有约定的，按照其约定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十五条&emsp;当事人采用合同书形式订立合同的，双方当事人签字或者盖章的地点为合同成立的地点。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十六条&emsp;法律、行政法规规定或者当事人约定采用书面形式订立合同，当事人未采用书面形式但一方已经履行</span><a href="https://baike.baidu.com/item/%E4%B8%BB%E8%A6%81%E4%B9%89%E5%8A%A1"><u><span>主要义务</span></u></a><span>，对方接受的，该合同成立。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十七条&emsp;采用合同书形式订立合同，在签字或者盖章之前，当事人一方已经履行主要义务，对方接受的，该合同成立。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十八条&emsp;国家根据需要下达指令性任务或者国家订货任务的，有关法人、其他组织之间应当依照有关法律、行政法规规定的权利和义务订立合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三十九条&emsp;采用</span><a href="https://baike.baidu.com/item/%E6%A0%BC%E5%BC%8F%E6%9D%A1%E6%AC%BE"><u><span>格式条款</span></u></a><span>订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>格式条款是当事人为了重复使用而预先拟定，并在订立合同时未与对方协商的条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十条&emsp;格式条款具有本法第五十二条和第五十三条规定情形的，或者提供格式条款一方免除其责任、加重对方责任、</span> 排除对方主要权利的，该条款无效。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十一条&emsp;对格式条款的理解发生争议的，应当按照通常理解予以解释。对格式条款有两种以上解释的，应当作出不利于提供格式条款一方的解释。格式条款和非格式条款不一致的，应当采用非格式条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十二条&emsp;当事人在订立合同过程中有下列情形之一，给对方造成损失的，应当承担损害赔偿责任：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）假借订立合同，恶意进行磋商；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）故意隐瞒与订立合同有关的重要事实或者提供虚假情况；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）有其他违背诚实信用原则的行为。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十三条&emsp;当事人在订立合同过程中知悉的</span><a href="https://baike.baidu.com/item/%E5%95%86%E4%B8%9A%E7%A7%98%E5%AF%86"><u><span>商业秘密</span></u></a><span>，无论合同是否成立，不得泄露或者不正当地使用。泄露或者不正当地使用该商业秘密给对方造成损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第三章&emsp;合同的效力</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十四条&emsp;依法成立的合同，自成立时生效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律、行政法规规定应当办理批准、登记等</span><a href="https://baike.baidu.com/item/%E6%89%8B%E7%BB%AD"><u><span>手续</span></u></a><span>生效的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十五条&emsp;当事人对合同的效力可以约定附条件。附生效条件的合同，自条件成就时生效。附解除条件的合同，自条件成就时失效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人为自己的利益不正当地阻止条件成就的，视为条件已成就；不正当地促成条件成就的，视为条件不成就。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十六条&emsp;当事人对合同的效力可以约定附期限。附生效期限的合同，自期限届至时生效。附终止期限的合同，自期限届满时失效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十七条&emsp;</span><a href="https://baike.baidu.com/item/%E9%99%90%E5%88%B6%E6%B0%91%E4%BA%8B%E8%A1%8C%E4%B8%BA%E8%83%BD%E5%8A%9B%E4%BA%BA"><u><span>限制民事行为能力人</span></u></a><span>订立的合同，经</span><a href="https://baike.baidu.com/item/%E6%B3%95%E5%AE%9A%E4%BB%A3%E7%90%86%E4%BA%BA"><u><span>法定代理人</span></u></a><span>追认后，该合同有效，但纯获利益的合同或者与其年龄、智力、精神健康状况相适应而订立的合同，不必经法定代理人追认。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>相对人可以催告法定代理人在一个月内予以追认。法定代理人未作表示的，视为拒绝追认。合同被追认之前，善意相对人有撤销的权利。撤销应当以通知的方式作出。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十八条&emsp;行为人没有</span><a href="https://baike.baidu.com/item/%E4%BB%A3%E7%90%86%E6%9D%83"><u><span>代理权</span></u></a><span>、超越代理权或者代理权终止后以被代理人名义订立的合同，未经被代理人追认，对被代理人不发生效力，由行为人承担责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>相对人可以催告被代理人在一个月内予以追认。被代理人未作表示的，视为拒绝追认。合同被追认之前，善意相对人有撤销的权利。撤销应当以通知的方式作出。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四十九条&emsp;行为人没有代理权、超越代理权或者代理权终止后以被代理人名义订立合同，相对人有理由相信行为人有代理权的，该代理行为有效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十条&emsp;法人或者其他组织的</span><a href="https://baike.baidu.com/item/%E6%B3%95%E5%AE%9A%E4%BB%A3%E8%A1%A8%E4%BA%BA"><u><span>法定代表人</span></u></a><span>、负责人超越权限订立的合同，除相对人知道或者应当知道其超越权限的以外，该代表行为有效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十一条&emsp;无处分权的人处分他人</span><a href="https://baike.baidu.com/item/%E8%B4%A2%E4%BA%A7"><u><span>财产</span></u></a><span>，经权利人追认或者无处分权的人订立合同后取得处分权的，该合同有效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十二条&emsp;有下列情形之一的，合同无效：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）一方以欺诈、胁迫的手段订立合同，损害国家利益；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）恶意串通，损害国家、</span><a href="https://baike.baidu.com/item/%E9%9B%86%E4%BD%93"><u><span>集体</span></u></a><span>或者第三人利益；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）以合法形式掩盖非法目的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）损害社会公共利益；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）违反法律、行政法规的强制性规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十三条&emsp;合同中的下列免责条款无效：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）造成对方人身伤害的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）因故意或者重大过失造成对方财产损失的。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十四条&emsp;下列合同，当事人一方有权请求</span><a href="https://baike.baidu.com/item/%E4%BA%BA%E6%B0%91%E6%B3%95%E9%99%A2"><u><span>人民法院</span></u></a><span>或者</span><a href="https://baike.baidu.com/item/%E4%BB%B2%E8%A3%81%E6%9C%BA%E6%9E%84"><u><span>仲裁机构</span></u></a><span>变更或者撤销：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）因重大误解订立的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）在订立合同时显失公平的。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>一方以欺诈、胁迫的手段或者</span><a href="https://baike.baidu.com/item/%E4%B9%98%E4%BA%BA%E4%B9%8B%E5%8D%B1"><u><span>乘人之危</span></u></a><span>，使对方在违背真实意思的情况下订立的合同，受损害方有权请求人民法院或者仲裁机构变更或者撤销。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人请求变更的，人民法院或者仲裁机构不得撤销。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十五条&emsp;有下列情形之一的，撤销权消灭：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）具有撤销权的当事人自知道或者应当知道撤销事由之日起一年内没有行使撤销权；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）具有撤销权的当事人知道撤销事由后明确表示或者以自己的行为放弃撤销权。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十六条&emsp;无效的合同或者被撤销的合同自始没有法律约束力。合同部分无效，不影响其他部分效力的，其他部分仍然有效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十七条&emsp;合同无效、被撤销或者终止的，不影响合同中独立存在的有关解决争议方法的条款的效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十八条&emsp;合同无效或者被撤销后，因该合同取得的财产，应当予以返还；不能返还或者没有必要返还的，应当折价补偿。有过错的一方应当赔偿对方因此所受到的损失，双方都有过错的，应当各自承担相应的责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第五十九条&emsp;当事人恶意串通，损害国家、集体或者第三人利益的，因此取得的财产收归</span><a href="https://baike.baidu.com/item/%E5%9B%BD%E5%AE%B6%E6%89%80%E6%9C%89"><u><span>国家所有</span></u></a><span>或者返还集体、第三人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第四章&emsp;合同的履行</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十条&emsp;当事人应当按照约定全面履行自己的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人应当遵循诚实信用原则，根据合同的性质、目的和交易习惯履行通知、协助、保密等义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十一条&emsp;</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E7%94%9F%E6%95%88"><u><span>合同生效</span></u></a><span>后，当事人就质量、价款或者报酬、履行地点等内容没有约定或者约定不明确的，可以协议补充；不能达成补充协议的，按照合同有关条款或者交易习惯确定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十二条&emsp;当事人就有关合同内容约定不明确，依照本法第六十一条的规定仍不能确定的，适用下列规定：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）</span><a href="https://baike.baidu.com/item/%E8%B4%A8%E9%87%8F%E8%A6%81%E6%B1%82"><u><span>质量要求</span></u></a><span>不明确的，按照国家标准、行业标准履行；没有国家标准、行业标准的，按照通常标准或者符合</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E7%9B%AE%E7%9A%84"><u><span>合同目的</span></u></a><span>的特定标准履行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）价款或者报酬不明确的，按照订立合同时履行地的市场价格履行；依法应当执行政府定价或者</span><a href="https://baike.baidu.com/item/%E6%94%BF%E5%BA%9C%E6%8C%87%E5%AF%BC%E4%BB%B7"><u><span>政府指导价</span></u></a><span>的，按照规定履行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）履行地点不明确，给付货币的，在接受货币一方所在地履行；交付不动产的，在不动产所在地履行；其他标的，在履行义务一方所在地履行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）履行期限不明确的，债务人可以随时履行，</span><a href="https://baike.baidu.com/item/%E5%80%BA%E6%9D%83%E4%BA%BA"><u><span>债权人</span></u></a><span>也可以随时要求履行，但应当给对方必要的准备时间。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）履行方式不明确的，按照有利于实现合同目的的方式履行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（六）履行费用的负担不明确的，由履行义务一方负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十三条&emsp;执行政府定价或者政府指导价的，在合同约定的交付期限内政府价格调整时，按照交付时的价格计价。逾期交付标的物的，遇价格上涨时，按照原价格执行；价格下降时，按照新价格执行。逾期提取标的物或者逾期付款的，遇价格上涨时，按照新价格执行；价格下降时，按照原价格执行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十四条&emsp;当事人约定由债务人向</span><a href="https://baike.baidu.com/item/%E7%AC%AC%E4%B8%89%E4%BA%BA%E5%B1%A5%E8%A1%8C"><u><span>第三人履行</span></u></a><span>债务的，债务人未向第三人履行债务或者履行债务不符合约定，应当向</span><a href="https://baike.baidu.com/item/%E5%80%BA%E6%9D%83"><u><span>债权</span></u></a><span>人承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十五条&emsp;当事人约定由第三人向债权人履行债务的，第三人不履行债务或者履行债务不符合约定，债务人应当向债权人承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十六条&emsp;当事人互负债务，没有先后履行顺序的，应当同时履行。一方在对方履行之前有权拒绝其履行要求。一方在对方履行债务不符合约定时，有权拒绝其相应的履行要求。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十七条&emsp;当事人互负债务，有先后履行顺序，先履行一方未履行的，后履行一方有权拒绝其履行要求。先履行一方履行债务不符合约定的，后履行一方有权拒绝其相应的履行要求。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十八条&emsp;应当先履行债务的当事人，有确切证据证明对方有下列情形之一的，可以中止履行：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）经营状况严重恶化；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）转移财产、抽逃资金，以逃避债务；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）丧失</span><a href="https://baike.baidu.com/item/%E5%95%86%E4%B8%9A%E4%BF%A1%E8%AA%89"><u><span>商业信誉</span></u></a><span>；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）有丧失或者可能丧失履行债务能力的其他情形。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人没有确切证据中止履行的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第六十九条&emsp;当事人依照本法第六十八条的规定中止履行的，应当及时通知对方。对方提供适当担保时，应当恢复履行。中止履行后，对方在合理期限内未恢复履行能力并且未提供适当担保的，中止履行的一方可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十条&emsp;债权人分立、合并或者变更住所没有通知债务人，致使履行债务发生困难的，债务人可以中止履行或者将标的物提存。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十一条&emsp;债权人可以拒绝债务人提前履行债务，但提前履行不损害债权人利益的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>债务人提前履行债务给债权人增加的费用，由债务人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十二条&emsp;债权人可以拒绝债务人</span><a href="https://baike.baidu.com/item/%E9%83%A8%E5%88%86%E5%B1%A5%E8%A1%8C"><u><span>部分履行</span></u></a><span>债务，但部分履行不损害债权人利益的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>债务人部分履行债务给债权人增加的费用，由债务人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十三条&emsp;因债务人怠于行使其到期债权，对债权人造成损害的，债权人可以向人民法院请求以自己的名义代位行使债务人的债权，但该债权专属于债务人自身的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<a href="https://baike.baidu.com/item/%E4%BB%A3%E4%BD%8D%E6%9D%83"><u><span>代位权</span></u></a><span>的行使范围以债权人的债权为限。债权人行使代位权的必要费用，由债务人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十四条&emsp;因债务人放弃其到期债权或者无偿转让财产，对债权人造成损害的，债权人可以请求人民法院撤销债务人的行为。债务人以明显不合理的低价转让财产，对债权人造成损害，并且受让人知道该情形的，债权人也可以请求人民法院撤销债务人的行为。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>撤销权的行使范围以债权人的债权为限。债权人行使撤销权的必要费用，由债务人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十五条&emsp;撤销权自债权人知道或者应当知道撤销事由之日起一年内行使。自债务人的行为发生之日起五年内没有行使撤销权的，该撤销权消灭。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十六条&emsp;合同生效后，当事人不得因姓名、名称的变更或者法定代表人、负责人、</span><a href="https://baike.baidu.com/item/%E6%89%BF%E5%8A%9E%E4%BA%BA"><u><span>承办人</span></u></a><span>的变动而不履行合同义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第五章&emsp;变更和转让</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十七条&emsp;当事人协商一致，可以变更合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律、行政法规规定变更合同应当办理批准、登记等手续的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十八条&emsp;当事人对</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E5%8F%98%E6%9B%B4"><u><span>合同变更</span></u></a><span>的内容约定不明确的，推定为未变更。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第七十九条&emsp;债权人可以将合同的权利全部或者部分转让给第三人，但有下列情形之一的除外：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）根据合同性质不得转让；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）按照当事人约定不得转让；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）依照法律规定不得转让。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十条&emsp;债权人转让权利的，应当通知债务人。未经通知，该转让对债务人不发生效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>债权人转让权利的通知不得撤销，但经受让人同意的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十一条&emsp;债权人转让权利的，受让人取得与债权有关的从权利，但该从权利专属于债权人自身的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十二条&emsp;债务人接到债权转让通知后，债务人对让与人的抗辩，可以向受让人主张。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十三条&emsp;债务人接到债权转让通知时，债务人对让与人享有债权，并且债务人的债权先于转让的债权到期或者同时到期的，债务人可以向受让人主张抵销。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十四条&emsp;债务人将合同的义务全部或者部分转移给第三人的，应当经债权人同意。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十五条&emsp;债务人转移义务的，新债务人可以主张原债务人对债权人的抗辩。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十六条&emsp;债务人转移义务的，新债务人应当承担与主债务有关的从债务，但该从债务专属于原债务人自身的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十七条&emsp;法律、行政法规规定转让权利或者转移义务应当办理批准、登记等手续的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十八条&emsp;当事人一方经对方同意，可以将自己在合同中的权利和义务一并转让给第三人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第八十九条&emsp;权利和义务一并转让的，适用本法第七十九条、第八十一条至第八十三条、第八十五条至第八十七条的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十条&emsp;当事人订立合同后合并的，由合并后的法人或者其他组织行使</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E6%9D%83%E5%88%A9"><u><span>合同权利</span></u></a><span>，履行合同义务。当事人订立合同后分立的，除债权人和债务人另有约定的以外，由分立的法人或者其他组织对合同的权利和义务享有连带债权，承担</span><a href="https://baike.baidu.com/item/%E8%BF%9E%E5%B8%A6%E5%80%BA%E5%8A%A1"><u><span>连带债务</span></u></a><span>。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第六章&emsp;权利义务终止</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十一条&emsp;有下列情形之一的，合同的权利义务终止：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）债务已经按照约定履行；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）</span><a href="https://baike.baidu.com/item/%E5%90%88%E5%90%8C%E8%A7%A3%E9%99%A4"><u><span>合同解除</span></u></a><span>；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）债务相互抵销；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）债务人依法将标的物提存；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）债权人免除债务；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（六）债权债务同归于一人；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（七）法律规定或者当事人约定终止的其他情形。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十二条&emsp;合同的权利义务终止后，当事人应当遵循诚实信用原则，根据交易习惯履行通知、协助、保密等义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十三条&emsp;当事人协商一致，可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人可以约定一方解除合同的条件。解除合同的条件成就时，解除权人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十四条&emsp;有下列情形之一的，当事人可以解除合同：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）因不可抗力致使不能实现合同目的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）在履行期限届满之前，当事人一方明确表示或者以自己的行为表明不履行主要债务；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）当事人一方迟延履行主要债务，经催告后在合理期限内仍未履行；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）当事人一方迟延履行债务或者有其他</span><a href="https://baike.baidu.com/item/%E8%BF%9D%E7%BA%A6%E8%A1%8C%E4%B8%BA"><u><span>违约行为</span></u></a><span>致使不能实现合同目的；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）法律规定的其他情形。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十五条&emsp;法律规定或者当事人约定解除权行使期限，期限届满当事人不行使的，该权利消灭。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律没有规定或者当事人没有约定解除权行使期限，经对方催告后在合理期限内不行使的，该权利消灭。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十六条&emsp;当事人一方依照本法第九十三条第二款、第九十四条的规定主张解除合同的，应当通知对方。合同自通知到达对方时解除。对方有异议的，可以请求人民法院或者仲裁机构确认解除合同的效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律、行政法规规定解除合同应当办理批准、登记等手续的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十七条&emsp;合同解除后，尚未履行的，终止履行；已经履行的，根据履行情况和合同性质，当事人可以要求恢复原状、采取其他补救措施，并有权要求赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十八条&emsp;合同的权利义务终止，不影响合同中结算和清理条款的效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第九十九条&emsp;当事人互负到期债务，该债务的标的物种类、品质相同的，任何一方可以将自己的债务与对方的</span><a href="https://baike.baidu.com/item/%E5%80%BA%E5%8A%A1%E6%8A%B5%E9%94%80"><u><span>债务抵销</span></u></a><span>，但依照法律规定或者按照合同性质不得抵销的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人主张抵销的，应当通知对方。通知自到达对方时生效。抵销不得附条件或者附期限。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百条&emsp;当事人互负债务，标的物种类、品质不相同的，经双方协商一致，也可以抵销。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零一条&emsp;有下列情形之一，难以履行债务的，债务人可以将标的物提存：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）债权人无正当理由拒绝受领；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）债权人下落不明；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）债权人死亡未确定继承人或者丧失民事行为能力未确定监护人；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）法律规定的其他情形。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>标的物不适于提存或者提存费用过高的，债务人依法可以拍卖或者变卖标的物，提存所得的价款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零二条&emsp;标的物提存后，除债权人下落不明的以外，债务人应当及时通知债权人或者债权人的继承人、监护人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零三条&emsp;标的物提存后，毁损、灭失的</span><a href="https://baike.baidu.com/item/%E9%A3%8E%E9%99%A9"><u><span>风险</span></u></a><span>由债权人承担。提存期间，标的物的孳息归债权人所有。提存费用由债权人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零四条&emsp;债权人可以随时领取提存物，但债权人对债务人负有到期债务的，在债权人未履行债务或者提供担保之前，提存部门根据债务人的要求应当拒绝其领取提存物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>债权人领取提存物的权利，自提存之日起五年内不行使而消灭，提存物扣除提存费用后归国家所有。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零五条&emsp;债权人免除债务人部分或者全部债务的，合同的权利义务部分或者全部终止。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零六条&emsp;债权和债务同归于一人的，合同的权利义务终止，但涉及第三人利益的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第七章&emsp;违约责任</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零七条&emsp;当事人一方不履行合同义务或者履行合同义务不符合约定的，应当承担继续履行、采取补救措施或者赔偿损失等违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零八条&emsp;当事人一方明确表示或者以自己的行为表明不履行合同义务的，对方可以在履行期限届满之前要求其承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百零九条&emsp;当事人一方未支付价款或者报酬的，对方可以要求其支付价款或者报酬。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十条&emsp;当事人一方不履行非金钱债务或者履行非金钱债务不符合约定的，对方可以要求履行，但有下列情形之一的除外：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）法律上或者事实上不能履行；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）债务的标的不适于强制履行或者履行费用过高；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）债权人在合理期限内未要求履行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十一条&emsp;质量不符合约定的，应当按照当事人的约定承担违约责任。对违约责任没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，受损害方根据标的的性质以及损失的大小，可以合理选择要求对方承担修理、更换、重作、退货、减少价款或者报酬等违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十二条&emsp;当事人一方不履行合同义务或者履行合同义务不符合约定的，在履行义务或者采取补救措施后，对方还有其他损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十三条&emsp;当事人一方不履行合同义务或者履行合同义务不符合约定，给对方造成损失的，损失赔偿额应当相当于因违约所造成的损失，包括合同履行后可以获得的利益，但不得超过违反合同一方订立合同时预见到或者应当预见到的因违反合同可能造成的损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>经营者对消费者提供商品或者</span><a href="https://baike.baidu.com/item/%E6%9C%8D%E5%8A%A1"><u><span>服务</span></u></a><span>有欺诈行为的，依照《</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%B6%88%E8%B4%B9%E8%80%85%E6%9D%83%E7%9B%8A%E4%BF%9D%E6%8A%A4%E6%B3%95"><u><span>中华人民共和国消费者权益保护法</span></u></a><span>》的规定承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十四条&emsp;当事人可以约定一方违约时应当根据违约情况向对方支付一定数额的</span><a href="https://baike.baidu.com/item/%E8%BF%9D%E7%BA%A6%E9%87%91"><u><span>违约金</span></u></a><span>，也可以约定因违约产生的损失赔偿额的计算方法。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>约定的违约金低于造成的损失的，当事人可以请求人民法院或者仲裁机构予以增加；约定的违约金过分高于造成的损失的，当事人可以请求人民法院或者仲裁机构予以适当减少。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人就迟延履行约定违约金的，违约方支付违约金后，还应当履行债务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十五条&emsp;当事人可以依照《</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%8B%85%E4%BF%9D%E6%B3%95"><u><span>中华人民共和国担保法</span></u></a><span>》约定一方向对方给付定金作为债权的担保。债务人履行债务后，定金应当抵作价款或者收回。给付定金的一方不履行约定的债务的，无权要求返还定金；收受定金的一方不履行约定的债务的，应当双倍返还定金。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十六条&emsp;当事人既约定违约金，又约定定金的，一方违约时，对方可以选择适用违约金或者定金条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十七条&emsp;因不可抗力不能履行合同的，根据不可抗力的影响，部分或者全部免除责任，但法律另有规定的除外。当事人迟延履行后发生不可抗力的，不能免除责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>本法所称不可抗力，是指不能预见、不能避免并不能克服的客观情况。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十八条&emsp;当事人一方因不可抗力不能履行合同的，应当及时通知对方，以减轻可能给对方造成的损失，并应当在合理期限内提供证明。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百一十九条&emsp;当事人一方违约后，对方应当采取适当</span><a href="https://baike.baidu.com/item/%E6%8E%AA%E6%96%BD"><u><span>措施</span></u></a><span>防止损失的扩大；没有采取适当措施致使损失扩大的，不得就扩大的损失要求赔偿。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人因防止损失扩大而支出的合理费用，由违约方承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十条&emsp;当事人双方都违反合同的，应当各自承担相应的责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十一条&emsp;当事人一方因第三人的原因造成违约的，应当向对方承担违约责任。当事人一方和第三人之间的纠纷，依照法律规定或者按照约定解决。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十二条&emsp;因当事人一方的违约行为，侵害对方人身、财产权益的，受损害方有权选择依照本法要求其承担违约责任或者依照其他法律要求其承担</span><a href="https://baike.baidu.com/item/%E4%BE%B5%E6%9D%83%E8%B4%A3%E4%BB%BB"><u><span>侵权责任</span></u></a><span>。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第八章&emsp;其他规定</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十三条&emsp;其他法律对合同另有规定的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十四条&emsp;本法分则或者其他法律没有明文规定的合同，适用本法</span><a href="https://baike.baidu.com/item/%E6%80%BB%E5%88%99"><u><span>总则</span></u></a><span>的规定，并可以参照本法分则或者其他法律最相类似的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十五条&emsp;当事人对合同条款的理解有争议的，应当按照合同所使用的词句、合同的有关条款、合同的目的、交易习惯以及诚实信用原则，确定该条款的真实意思。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>合同文本采用两种以上文字订立并约定具有同等效力的，对各文本使用的词句推定具有相同含义。各文本使用的词句不一致的，应当根据合同的目的予以解释。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十六条&emsp;</span><a href="https://baike.baidu.com/item/%E6%B6%89%E5%A4%96%E5%90%88%E5%90%8C"><u><span>涉外合同</span></u></a><span>的当事人可以选择处理合同争议所适用的法律，但法律另有规定的除外。涉外合同的当事人没有选择的，适用与合同有最密切联系的国家的法律。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>在</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD"><u><span>中华人民共和国</span></u></a><span>境内履行的中外合资经营企业合同、</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%A4%96%E5%90%88%E4%BD%9C%E7%BB%8F%E8%90%A5%E4%BC%81%E4%B8%9A"><u><span>中外合作经营企业</span></u></a><span>合同、中外合作勘探开发自然资源合同，适用</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%B3%95%E5%BE%8B"><u><span>中华人民共和国法律</span></u></a><span>。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十七条&emsp;工商行政管理部门和其他有关行政主管部门在各自的职权范围内，依照法律、行政法规的规定，对利用合同危害国家利益、社会公共利益的</span><a href="https://baike.baidu.com/item/%E8%BF%9D%E6%B3%95%E8%A1%8C%E4%B8%BA"><u><span>违法行为</span></u></a><span>，负责监督处理；构成犯罪的，依法追究刑事责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十八条&emsp;当事人可以通过和解或者调解解决合同争议。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人不愿和解、调解或者和解、调解不成的，可以根据</span><a href="https://baike.baidu.com/item/%E4%BB%B2%E8%A3%81%E5%8D%8F%E8%AE%AE"><u><span>仲裁协议</span></u></a><span>向仲裁机构申请仲裁。涉外合同的当事人可以根据仲裁协议向中国仲裁机构或者其他仲裁机构申请仲裁。当事人没有订立仲裁协议或者仲裁协议无效的，可以向人民法院起诉。当事人应当履行发生法律效力的判决、</span><a href="https://baike.baidu.com/item/%E4%BB%B2%E8%A3%81%E8%A3%81%E5%86%B3"><u><span>仲裁裁决</span></u></a><span>、调解书；拒不履行的，对方可以请求人民法院执行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百二十九条&emsp;因国际货物买卖合同和</span><a href="https://baike.baidu.com/item/%E6%8A%80%E6%9C%AF%E8%BF%9B%E5%87%BA%E5%8F%A3%E5%90%88%E5%90%8C"><u><span>技术进出口合同</span></u></a><span>争议提起诉讼或者申请仲裁的期限为四年，自当事人知道或者应当知道其权利受到侵害之日起计算。因其他合同争议提起诉讼或者申请仲裁的期限，依照有关法律的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第九章&emsp;买卖合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十条&emsp;买卖合同是出卖人转移标的物的</span><a href="https://baike.baidu.com/item/%E6%89%80%E6%9C%89%E6%9D%83"><u><span>所有权</span></u></a><span>于买受人，买受人支付价款的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十一条&emsp;买卖合同的内容除依照本法</span> 第十二条的规定以外，还可以包括包装方式、检验标准和方法、结算方式、合同使用的文字及其效力等条款。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十二条&emsp;出卖的标的物，应当属于出卖人所有或者出卖人有权处分。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>法律、行政法规禁止或者限制转让的标的物，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十三条&emsp;标的物的所有权自标的物交付时起转移，但法律另有规定或者当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十四条&emsp;当事人可以在买卖合同中约定买受人未履行支付价款或者其他义务的，标的物的所有权属于出卖人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十五条&emsp;出卖人应当履行向买受人交付标的物或者交付提取标的物的单证，并转移标的物所有权的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十六条&emsp;出卖人应当按照约定或者交易习惯向买受人交付提取标的物单证以外的有关单证和资料。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十七条&emsp;出卖具有</span><a href="https://baike.baidu.com/item/%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83"><u><span>知识产权</span></u></a><span>的计算机软件等标的物的，除法律另有规定或者当事人另有约定的以外，该标的物的知识产权不属于买受人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十八条&emsp;出卖人应当按照约定的期限交付标的物。约定交付期间的，出卖人可以在该交付期间内的任何时间交付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百三十九条&emsp;当事人没有约定标的物的交付期限或者约定不明确的，适用本法第六十一条、第六十二条第四项的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十条&emsp;标的物在订立合同之前已为买受人占有的，合同生效的时间为交付时间。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十一条&emsp;出卖人应当按照约定的地点交付标的物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人没有约定交付地点或者约定不明确，依照本法第六十一条的规定仍不能确定的，适用下列规定：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）标的物需要运输的，出卖人应当将标的物交付给第一承运人以运交给买受人；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）标的物不需要运输，出卖人和买受人订立合同时知道标的物在某一地点的，出卖人应当在该地点交付标的物；不知道标的物在某一地点的，应当在出卖人订立合同时的营业地交付标的物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十二条&emsp;标的物毁损、灭失的风险，在标的物交付之前由出卖人承担，交付之后由买受人承担，但法律另有规定或者当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十三条&emsp;因买受人的原因致使标的物不能按照约定的期限交付的，买受人应当自违反约定之日起承担标的物毁损、灭失的风险。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十四条&emsp;出卖人出卖交由承运人运输的在途标的物，除当事人另有约定的以外，毁损、灭失的风险自合同成立时起由买受人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十五条&emsp;当事人没有约定交付地点或者约定不明确，依照本法第一百四十一条第二款第一项的规定标的物需要运输的，出卖人将标的物交付给第一承运人后，标的物毁损、灭失的风险由买受人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十六条&emsp;出卖人按照约定或者依照本法第一百四十一条第二款第二项的规定将标的物置于交付地点，买受人违反约定没有收取的，标的物毁损、灭失的风险自违反约定之日起由买受人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十七条&emsp;出卖人按照约定未交付有关标的物的单证和资料的，不影响标的物毁损、灭失风险的转移。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十八条&emsp;因标的物质量不符合质量要求，致使不能实现合同目的的，买受人可以拒绝接受标的物或者解除合同。买受人拒绝接受标的物或者解除合同的，标的物毁损、灭失的风险由出卖人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百四十九条&emsp;标的物毁损、灭失的风险由买受人承担的，不影响因出卖人履行债务不符合约定，买受人要求其承担违约责任的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十条&emsp;出卖人就交付的标的物，负有保证第三人不得向买受人主张任何权利的义务，但法律另有规定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十一条&emsp;买受人订立合同时知道或者应当知道第三人对买卖的标的物享有权利的，出卖人不承担本法第一百五十条规定的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十二条&emsp;买受人有确切证据证明第三人可能就标的物主张权利的，可以中止支付相应的价款，但出卖人提供适当担保的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十三条&emsp;出卖人应当按照约定的质量要求交付标的物。出卖人提供有关标的物质量说明的，交付的标的物应当符合该说明的质量要求。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十四条&emsp;当事人对标的物的质量要求没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，适用本法第六十二条第一项的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十五条&emsp;出卖人交付的标的物不符合质量要求的，买受人可以依照本法第一百一十一条的规定要求承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十六条&emsp;出卖人应当按照约定的包装方式交付标的物。对包装方式没有约定或者约定不明确，依照本法</span> 第六十一条的规定仍不能确定的，应当按照通用的方式包装，没有通用方式的，应当采取足以保护标的物的包装方式。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十七条&emsp;买受人收到标的物时应当在约定的检验期间内检验。没有约定检验期间的，应当及时检验。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十八条&emsp;当事人约定检验期间的，买受人应当在检验期间内将标的物的数量或者质量不符合约定的情形通知出卖人。买受人怠于通知的，视为标的物的数量或者质量符合约定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人没有约定检验期间的，买受人应当在发现或者应当发现标的物的数量或者质量不符合约定的合理期间内通知出卖人。买受人在合理期间内未通知或者自标的物收到之日起两年内未通知出卖人的，视为标的物的数量或者质量符合约定，但对标的物有质量保证期的，适用质量保证期，不适用该两年的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>出卖人知道或者应当知道提供的标的物不符合约定的，买受人不受前两款规定的通知时间的限制。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百五十九条&emsp;买受人应当按照约定的数额支付价款。对价款没有约定或者约定不明确的，适用本法第六十一条、第六十二条第二项的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十条&emsp;买受人应当按照约定的地点支付价款。对支付地点没有约定或者约定不明确，依照本法</span> 第六十一条的规定仍不能确定的，买受人应当在出卖人的营业地支付，但约定支付价款以交付标的物或者交付提取标的物单证为条件的，在交付标的物或者交付提取标的物单证的所在地支付。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十一条&emsp;买受人应当按照约定的时间支付价款。对支付时间没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，买受人应当在收到标的物或者提取标的物单证的同时支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十二条&emsp;出卖人多交标的物的，买受人可以接收或者拒绝接收多交的部分。买受人接收多交部分的，按照合同的价格支付价款；买受人拒绝接收多交部分的，应当及时通知出卖人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十三条&emsp;标的物在交付之前产生的孳息，归出卖人所有，交付之后产生的孳息，归买受人所有。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十四条&emsp;因标的物的主物不符合约定而解除合同的，解除合同的效力及于从物。因标的物的从物不符合约定被解除的，解除的效力不及于主物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十五条&emsp;标的物为数物，其中一物不符合约定的，买受人可以就该物解除，但该物与他物分离使标的物的价值显受损害的，当事人可以就数物解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十六条&emsp;出卖人分批交付标的物的，出卖人对其中一批标的物不交付或者交付不符合约定，致使该批标的物不能实现合同目的的，买受人可以就该批标的物解除。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>出卖人不交付其中一批标的物或者交付不符合约定，致使今后其他各批标的物的交付不能实现合同目的的，买受人可以就该批以及今后其他各批标的物解除。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>买受人如果就其中一批标的物解除，该批标的物与其他各批标的物相互依存的，可以就已经交付和未交付的各批标的物解除。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十七条&emsp;分期付款的买受人未支付到期价款的金额达到全部价款的五分之一的，出卖人可以要求买受人支付全部价款或者解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>出卖人解除合同的，可以向买受人要求支付该标的物的使用费。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十八条&emsp;凭样品买卖的当事人应当封存样品，并可以对样品质量予以说明。出卖人交付的标的物应当与样品及其说明的质量相同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百六十九条&emsp;凭样品买卖的买受人不知道样品有隐蔽瑕疵的，即使交付的标的物与样品相同，出卖人交付的标的物的质量仍然应当符合同种物的通常标准。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十条&emsp;试用买卖的当事人可以约定标的物的</span><a href="https://baike.baidu.com/item/%E8%AF%95%E7%94%A8%E6%9C%9F"><u><span>试用期</span></u></a><span>间。对试用期间没有约定或者约定不明确，依照本法</span> 第六十一条的规定仍不能确定的，由出卖人确定。
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十一条&emsp;试用买卖的买受人在试用期内可以购买标的物，也可以拒绝购买。试用期间届满，买受人对是否购买标的物未作表示的，视为购买。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十二条&emsp;</span><a href="https://baike.baidu.com/item/%E6%8B%9B%E6%A0%87%E6%8A%95%E6%A0%87%E4%B9%B0%E5%8D%96"><u><span>招标投标买卖</span></u></a><span>的当事人的权利和义务以及招标投标程序等，依照有关法律、行政法规的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十三条&emsp;拍卖的当事人的权利和义务以及拍卖程序等，依照有关法律、行政法规的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十四条&emsp;法律对其他有偿合同有规定的，依照其规定；没有规定的，参照买卖合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十五条&emsp;当事人约定易货交易，转移标的物的所有权的，参照买卖合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十章&emsp;供用电合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十六条&emsp;</span><a href="https://baike.baidu.com/item/%E4%BE%9B%E7%94%A8%E7%94%B5%E5%90%88%E5%90%8C"><u><span>供用电合同</span></u></a><span>是供电人向用电人供电，用电人支付电费的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十七条&emsp;供用电合同的内容包括供电的方式、质量、时间，用电容量、地址、性质，计量方式，电价、电费的结算方式，供用电设施的维护责任等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十八条&emsp;供用电合同的履行地点，按照当事人约定；当事人没有约定或者约定不明确的，供电设施的产权分界处为履行地点。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百七十九条&emsp;供电人应当按照国家规定的供电质量标准和约定安全供电。供电人未按照国家规定的供电质量标准和约定安全供电，造成用电人损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十条&emsp;供电人因供电设施计划检修、临时检修、依法限电或者用电人违法用电等原因，需要中断供电时，应当按照国家有关规定事先通知用电人。未事先通知用电人中断供电，造成用电人损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十一条&emsp;因自然灾害等原因断电，供电人应当按照国家有关规定及时抢修。未及时抢修，造成用电人损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十二条&emsp;用电人应当按照国家有关规定和当事人的约定及时交付电费。用电人逾期不交付电费的，应当按照约定支付违约金。经催告用电人在合理期限内仍不交付电费和违约金的，供电人可以按照国家规定的程序中止供电。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十三条&emsp;用电人应当按照国家有关规定和当事人的约定安全用电。用电人未按照国家有关规定和当事人的约定安全用电，造成供电人损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十四条&emsp;供用水、供用气、供用热力合同，参照供用电合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十一章&emsp;赠与合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十五条&emsp;赠与合同是赠与人将自己的财产无偿给予受赠人，受赠人表示接受赠与的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十六条&emsp;赠与人在赠与财产的权利转移之前可以撤销赠与。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>具有救灾、扶贫等社会公益、</span><a href="https://baike.baidu.com/item/%E9%81%93%E5%BE%B7%E4%B9%89%E5%8A%A1"><u><span>道德义务</span></u></a><span>性质的赠与合同或者经过公证的赠与合同，不适用前款规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十七条&emsp;赠与的财产依法需要办理登记等手续的，应当办理有关手续。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十八条&emsp;具有救灾、扶贫等社会公益、道德义务性质的赠与合同或者经过公证的赠与合同，赠与人不交付赠与的财产的，受赠人可以要求交付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百八十九条&emsp;因赠与人故意或者重大过失致使赠与的财产毁损、灭失的，赠与人应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十条&emsp;赠与可以附义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>赠与附义务的，受赠人应当按照约定履行义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十一条&emsp;赠与的财产有瑕疵的，赠与人不承担责任。附义务的赠与，赠与的财产有瑕疵的，赠与人在附义务的限度内承担与出卖人相同的责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>赠与人故意不告知瑕疵或者保证无瑕疵，造成受赠人损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十二条&emsp;受赠人有下列情形之一的，赠与人可以撤销赠与：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）严重侵害赠与人或者赠与人的近亲属；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）对赠与人有扶养义务而不履行；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）不履行赠与合同约定的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>赠与人的撤销权，自知道或者应当知道撤销原因之日起一年内行使。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十三条&emsp;因受赠人的违法行为致使赠与人死亡或者丧失民事行为能力的，赠与人的继承人或者法定代理人可以撤销赠与。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>赠与人的继承人或者法定代理人的撤销权，自知道或者应当知道撤销原因之日起六个月内行使。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十四条&emsp;撤销权人撤销赠与的，可以向受赠人要求返还赠与的财产。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十五条&emsp;赠与人的经济状况显著恶化，严重影响其生产经营或者家庭生活的，可以不再履行赠与义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十二章</span> 借款合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十六条&emsp;借款合同是借款人向贷款人借款，到期返还借款并支付利息的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十七条&emsp;借款合同采用书面形式，但自然人之间借款另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>借款合同的内容包括借款种类、币种、用途、数额、利率、期限和还款方式等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十八条&emsp;订立借款合同，贷款人可以要求借款人提供担保。担保依照《中华人民共和国担保法》的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第一百九十九条&emsp;订立借款合同，借款人应当按照贷款人的要求提供与借款有关的业务活动和财务状况的真实情况。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百条&emsp;借款的利息不得预先在本金中扣除。利息预先在本金中扣除的，应当按照实际借款数额返还借款并计算利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零一条&emsp;贷款人未按照约定的日期、数额提供借款，造成借款人损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>借款人未按照约定的日期、数额收取借款的，应当按照约定的日期、数额支付利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零二条&emsp;贷款人按照约定可以检查、监督借款的使用情况。借款人应当按照约定向贷款人定期提供有关财务会计报表等资料。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零三条&emsp;借款人未按照约定的借款用途使用借款的，贷款人可以停止发放借款、提前收回借款或者解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零四条&emsp;办理贷款业务的金融机构贷款的利率，应当按照中国人民银行规定的贷款利率的上下限确定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零五条&emsp;借款人应当按照约定的期限支付利息。对支付利息的期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定，借款期间不满一年的，应当在返还借款时一并支付；借款期间一年以上的，应当在每届满一年时支付，剩余期间不满一年的，应当在返还借款时一并支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零六条&emsp;借款人应当按照约定的期限返还借款。对借款期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，借款人可以随时返还；贷款人可以催告借款人在合理期限内返还。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零七条&emsp;借款人未按照约定的期限返还借款的，应当按照约定或者国家有关规定支付逾期利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零八条&emsp;借款人提前偿还借款的，除当事人另有约定的以外，应当按照实际借款的期间计算利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百零九条&emsp;借款人可以在还款期限届满之前向贷款人申请展期。贷款人同意的，可以展期。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十条&emsp;自然人之间的借款合同，自贷款人提供借款时生效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十一条&emsp;自然人之间的借款合同对支付利息没有约定或者约定不明确的，视为不支付利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>自然人之间的借款合同约定支付利息的，借款的利率不得违反国家有关限制借款利率的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十三章</span> 租赁合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十二条&emsp;租赁合同是出租人将租赁物交付承租人使用、收益，承租人支付租金的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十三条&emsp;租赁合同的内容包括租赁物的名称、数量、用途、租赁期限、租金及其支付期限和方式、租赁物维修等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十四条&emsp;租赁期限不得超过二十年。超过二十年的，超过部分无效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>租赁期间届满，当事人可以续订租赁合同，但约定的租赁期限自续订之日起不得超过二十年。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十五条&emsp;租赁期限六个月以上的，应当采用书面形式。当事人未采用书面形式的，视为不定期租赁。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十六条&emsp;出租人应当按照约定将租赁物交付承租人，并在租赁期间保持租赁物符合约定的用途。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十七条&emsp;承租人应当按照约定的方法使用租赁物。对租赁物的使用方法没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，应当按照租赁物的性质使用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十八条&emsp;承租人按照约定的方法或者租赁物的性质使用租赁物，致使租赁物受到损耗的，不承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百一十九条&emsp;承租人未按照约定的方法或者租赁物的性质使用租赁物，致使租赁物受到损失的，出租人可以解除合同并要求赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十条&emsp;出租人应当履行租赁物的维修义务，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十一条&emsp;承租人在租赁物需要维修时可以要求出租人在合理期限内维修。出租人未履行维修义务的，承租人可以自行维修，维修费用由出租人负担。因维修租赁物影响承租人使用的，应当相应减少租金或者延长租期。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十二条&emsp;承租人应当妥善保管租赁物，因保管不善造成租赁物毁损、灭失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十三条&emsp;承租人经出租人同意，可以对租赁物进行改善或者增设他物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承租人未经出租人同意，对租赁物进行改善或者增设他物的，出租人可以要求承租人恢复原状或者赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十四条&emsp;承租人经出租人同意，可以将租赁物转租给第三人。承租人转租的，承租人与出租人之间的租赁合同继续有效，第三人对租赁物造成损失的，承租人应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承租人未经出租人同意转租的，出租人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十五条&emsp;在租赁期间因占有、使用租赁物获得的收益，归承租人所有，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十六条&emsp;承租人应当按照约定的期限支付租金。对支付期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定，租赁期间不满一年的，应当在租赁期间届满时支付；租赁期间一年以上的，应当在每届满一年时支付，剩余期间不满一年的，应当在租赁期间届满时支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十七条&emsp;承租人无正当理由未支付或者迟延支付租金的，出租人可以要求承租人在合理期限内支付。承租人逾期不支付的，出租人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十八条&emsp;因第三人主张权利，致使承租人不能对租赁物使用、收益的，承租人可以要求减少租金或者不支付租金。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三人主张权利的，承租人应当及时通知出租人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百二十九条&emsp;租赁物在租赁期间发生所有权变动的，不影响租赁合同的效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十条&emsp;出租人出卖租赁房屋的，应当在出卖之前的合理期限内通知承租人，承租人享有以同等条件优先购买的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十一条&emsp;因不可归责于承租人的事由，致使租赁物部分或者全部毁损、灭失的，承租人可以要求减少租金或者不支付租金；因租赁物部分或者全部毁损、灭失，致使不能实现合同目的的，承租人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十二条&emsp;当事人对租赁期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，视为不定期租赁。当事人可以随时解除合同，但出租人解除合同应当在合理期限之前通知承租人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十三条&emsp;租赁物危及承租人的安全或者健康的，即使承租人订立合同时明知该租赁物质量不合格，承租人仍然可以随时解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十四条&emsp;承租人在房屋租赁期间死亡的，与其生前共同居住的人可以按照原租赁合同租赁该房屋。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十五条&emsp;租赁期间届满，承租人应当返还租赁物。返还的租赁物应当符合按照约定或者租赁物的性质使用后的状态。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十六条&emsp;租赁期间届满，承租人继续使用租赁物，出租人没有提出异议的，原租赁合同继续有效，但租赁期限为不定期。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十四章</span> 融资租赁合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十七条&emsp;融资租赁合同是出租人根据承租人对出卖人、租赁物的选择，向出卖人购买租赁物，提供给承租人使用，承租人支付租金的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十八条&emsp;融资租赁合同的内容包括租赁物名称、数量、规格、技术性能、检验方法、租赁期限、租金构成及其支付期限和方式、币种、租赁期间届满租赁物的归属等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>融资租赁合同应当采用书面形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百三十九条&emsp;出租人根据承租人对出卖人、租赁物的选择订立的买卖合同，出卖人应当按照约定向承租人交付标的物，承租人享有与受领标的物有关的买受人的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十条&emsp;出租人、出卖人、承租人可以约定，出卖人不履行买卖合同义务的，由承租人行使索赔的权利。承租人行使索赔权利的，出租人应当协助。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十一条&emsp;出租人根据承租人对出卖人、租赁物的选择订立的买卖合同，未经承租人同意，出租人不得变更与承租人有关的合同内容。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十二条&emsp;出租人享有租赁物的所有权。承租人破产的，租赁物不属于破产财产。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十三条&emsp;融资租赁合同的租金，除当事人另有约定的以外，应当根据购买租赁物的大部分或者全部成本以及出租人的合理利润确定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十四条&emsp;租赁物不符合约定或者不符合使用目的的，出租人不承担责任，但承租人依赖出租人的技能确定租赁物或者出租人干预选择租赁物的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十五条&emsp;出租人应当保证承租人对租赁物的占有和使用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十六条&emsp;承租人占有租赁物期间，租赁物造成第三人的人身伤害或者财产损害的，出租人不承担责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十七条&emsp;承租人应当妥善保管、使用租赁物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承租人应当履行占有租赁物期间的维修义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十八条&emsp;承租人应当按照约定支付租金。承租人经催告后在合理期限内仍不支付租金的，出租人可以要求支付全部租金；也可以解除合同，收回租赁物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百四十九条&emsp;当事人约定租赁期间届满租赁物归承租人所有，承租人已经支付大部分租金，但无力支付剩余租金，出租人因此解除合同收回租赁物的，收回的租赁物的价值超过承租人欠付的租金以及其他费用的，承租人可以要求部分返还。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十条&emsp;出租人和承租人可以约定租赁期间届满租赁物的归属。对租赁物的归属没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，租赁物的所有权归出租人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十五章</span> 承揽合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十一条&emsp;承揽合同是承揽人按照定作人的要求完成工作，交付工作成果，定作人给付报酬的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承揽包括加工、定作、修理、复制、测试、检验等工作。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十二条&emsp;承揽合同的内容包括承揽的标的、数量、质量、报酬、承揽方式、材料的提供、履行期限、验收标准和方法等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十三条&emsp;承揽人应当以自己的设备、技术和劳力，完成主要工作，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承揽人将其承揽的主要工作交由第三人完成的，应当就该第三人完成的工作成果向定作人负责；未经定作人同意的，定作人也可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十四条&emsp;承揽人可以将其承揽的辅助工作交由第三人完成。承揽人将其承揽的辅助工作交由第三人完成的，应当就该第三人完成的工作成果向定作人负责。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十五条&emsp;承揽人提供材料的，承揽人应当按照约定选用材料，并接受定作人检验。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十六条&emsp;定作人提供材料的，定作人应当按照约定提供材料。承揽人对定作人提供的材料，应当及时检验，发现不符合约定时，应当及时通知定作人更换、补齐或者采取其他补救措施。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>承揽人不得擅自更换定作人提供的材料，不得更换不需要修理的零部件。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十七条&emsp;承揽人发现定作人提供的图纸或者技术要求不合理的，应当及时通知定作人。因定作人怠于答复等原因造成承揽人损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十八条&emsp;定作人中途变更承揽工作的要求，造成承揽人损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百五十九条&emsp;承揽工作需要定作人协助的，定作人有协助的义务。定作人不履行协助义务致使承揽工作不能完成的，承揽人可以催告定作人在合理期限内履行义务，并可以顺延履行期限；定作人逾期不履行的，承揽人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十条&emsp;承揽人在工作期间，应当接受定作人必要的监督检验。定作人不得因监督检验妨碍承揽人的正常工作。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十一条&emsp;承揽人完成工作的，应当向定作人交付工作成果，并提交必要的技术资料和有关质量证明。定作人应当验收该工作成果。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十二条&emsp;承揽人交付的工作成果不符合质量要求的，定作人可以要求承揽人承担修理、重作、减少报酬、赔偿损失等违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十三条&emsp;定作人应当按照约定的期限支付报酬。对支付报酬的期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，定作人应当在承揽人交付工作成果时支付；工作成果部分交付的，定作人应当相应支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十四条&emsp;定作人未向承揽人支付报酬或者材料费等价款的，承揽人对完成的工作成果享有留置权，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十五条&emsp;承揽人应当妥善保管定作人提供的材料以及完成的工作成果，因保管不善造成毁损、灭失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十六条&emsp;承揽人应当按照定作人的要求保守秘密，未经定作人许可，不得留存复制品或者技术资料。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十七条&emsp;共同承揽人对定作人承担连带责任，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十八条&emsp;定作人可以随时解除承揽合同，造成承揽人损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十六章</span> 建设工程合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百六十九条&emsp;建设工程合同是承包人进行工程建设，发包人支付价款的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>建设工程合同包括工程勘察、设计、施工合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十条&emsp;建设工程合同应当采用书面形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十一条&emsp;建设工程的招标投标活动，应当依照有关法律的规定公开、公平、公正进行。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十二条&emsp;发包人可以与总承包人订立建设工程合同，也可以分别与勘察人、设计人、施工人订立勘察、设计、施工承包合同。发包人不得将应当由一个承包人完成的建设工程肢解成若干部分发包给几个承包人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>总承包人或者勘察、设计、施工承包人经发包人同意，可以将自己承包的部分工作交由第三人完成。第三人就其完成的工作成果与总承包人或者勘察、设计、施工承包人向发包人承担连带责任。承包人不得将其承包的全部建设工程转包给第三人或者将其承包的全部建设工程肢解以后以分包的名义分别转包给第三人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>禁止承包人将工程分包给不具备相应资质条件的单位。禁止分包单位将其承包的工程再分包。建设工程主体结构的施工必须由承包人自行完成。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十三条&emsp;国家重大建设工程合同，应当按照国家规定的程序和国家批准的投资计划、可行性研究报告等文件订立。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十四条&emsp;勘察、设计合同的内容包括提交有关基础资料和文件（包括概预算）的期限、质量要求、费用以及其他协作条件等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十五条&emsp;施工合同的内容包括工程范围、建设工期、中间交工工程的开工和竣工时间、工程质量、工程造价、技术资料交付时间、材料和设备供应责任、拨款和结算、竣工验收、质量保修范围和质量保证期、双方相互协作等条款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十六条&emsp;建设工程实行监理的，发包人应当与监理人采用书面形式订立委托监理合同。发包人与监理人的权利和义务以及法律责任，应当依照本法委托合同以及其他有关法律、行政法规的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十七条&emsp;发包人在不妨碍承包人正常作业的情况下，可以随时对作业进度、质量进行检查。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十八条&emsp;隐蔽工程在隐蔽以前，承包人应当通知发包人检查。发包人没有及时检查的，承包人可以顺延工程日期，并有权要求赔偿停工、窝工等损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百七十九条&emsp;建设工程竣工后，发包人应当根据施工图纸及说明书、国家颁发的施工验收规范和质量检验标准及时进行验收。验收合格的，发包人应当按照约定支付价款，并接收该建设工程。建设工程竣工经验收合格后，方可交付使用；未经验收或者验收不合格的，不得交付使用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十条&emsp;勘察、设计的质量不符合要求或者未按照期限提交勘察、设计文件拖延工期，造成发包人损失的，勘察人、设计人应当继续完善勘察、设计，减收或者免收勘察、设计费并赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十一条&emsp;因施工人的原因致使建设工程质量不符合约定的，发包人有权要求施工人在合理期限内无偿修理或者返工、改建。经过修理或者返工、改建后，造成逾期交付的，施工人应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十二条&emsp;因承包人的原因致使建设工程在合理使用期限内造成人身和财产损害的，承包人应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十三条&emsp;发包人未按照约定的时间和要求提供原材料、设备、场地、资金、技术资料的，承包人可以顺延工程日期，并有权要求赔偿停工、窝工等损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十四条&emsp;因发包人的原因致使工程中途停建、缓建的，发包人应当采取措施弥补或者减少损失，赔偿承包人因此造成的停工、窝工、倒运、机械设备调迁、材料和构件积压等损失和实际费用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十五条&emsp;因发包人变更计划，提供的资料不准确，或者未按照期限提供必需的勘察、设计工作条件而造成勘察、设计的返工、停工或者修改设计，发包人应当按照勘察人、设计人实际消耗的工作量增付费用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十六条&emsp;发包人未按照约定支付价款的，承包人可以催告发包人在合理期限内支付价款。发包人逾期不支付的，除按照建设工程的性质不宜折价、拍卖的以外，承包人可以与发包人协议将该工程折价，也可以申请人民法院将该工程依法拍卖。建设工程的价款就该工程折价或者拍卖的价款优先受偿。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十七条&emsp;本章没有规定的，适用承揽合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十七章</span> 运输合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第一节&emsp;一般规定</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十八条&emsp;运输合同是承运人将旅客或者货物从起运地点运输到约定地点，旅客、托运人或者收货人支付票款或者运输费用的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百八十九条&emsp;从事公共运输的承运人不得拒绝旅客、托运人通常、合理的运输要求。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十条&emsp;承运人应当在约定期间或者合理期间内将旅客、货物安全运输到约定地点。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十一条&emsp;承运人应当按照约定的或者通常的运输路线将旅客、货物运输到约定地点。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十二条&emsp;旅客、托运人或者收货人应当支付票款或者运输费用。承运人未按照约定路线或者通常路线运输增加票款或者运输费用的，旅客、托运人或者收货人可以拒绝支付增加部分的票款或者运输费用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二节&emsp;客运合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十三条&emsp;客运合同自承运人向旅客交付客票时成立，但当事人另有约定或者另有交易习惯的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十四条&emsp;旅客应当持有效客票乘运。旅客无票乘运、超程乘运、越级乘运或者持失效客票乘运的，应当补交票款，承运人可以按照规定加收票款。旅客不交付票款的，承运人可以拒绝运输。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十五条&emsp;旅客因自己的原因不能按照客票记载的时间乘坐的，应当在约定的时间内办理退票或者变更手续。逾期办理的，承运人可以不退票款，并不再承担运输义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十六条&emsp;旅客在运输中应当按照约定的限量携带行李。超过限量携带行李的，应当办理托运手续。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十七条&emsp;旅客不得随身携带或者在行李中夹带易燃、易爆、有毒、有腐蚀性、有放射性以及有可能危及运输工具上人身和财产安全的危险物品或者其他违禁物品。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>旅客违反前款规定的，承运人可以将违禁物品卸下、销毁或者送交有关部门。旅客坚持携带或者夹带违禁物品的，承运人应当拒绝运输。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十八条&emsp;承运人应当向旅客及时告知有关不能正常运输的重要事由和安全运输应当注意的事项。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第二百九十九条&emsp;承运人应当按照客票载明的时间和班次运输旅客。承运人迟延运输的，应当根据旅客的要求安排改乘其他班次或者退票。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百条&emsp;承运人擅自变更运输工具而降低服务标准的，应当根据旅客的要求退票或者减收票款；提高服务标准的，不应当加收票款。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零一条&emsp;承运人在运输过程中，应当尽力救助患有急病、分娩、遇险的旅客。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零二条&emsp;承运人应当对运输过程中旅客的伤亡承担损害赔偿责任，但伤亡是旅客自身健康原因造成的或者承运人证明伤亡是旅客故意、重大过失造成的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>前款规定适用于按照规定免票、持优待票或者经承运人许可搭乘的无票旅客。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零三条&emsp;在运输过程中旅客自带物品毁损、灭失，承运人有过错的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>旅客托运的行李毁损、灭失的，适用货物运输的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第三节&emsp;货运合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零四条&emsp;托运人办理货物运输，应当向承运人准确表明收货人的名称或者姓名或者凭指示的收货人，货物的名称、性质、重量、数量，收货地点等有关货物运输的必要情况。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>因托运人申报不实或者遗漏重要情况，造成承运人损失的，托运人应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零五条&emsp;货物运输需要办理审批、检验等手续的，托运人应当将办理完有关手续的文件提交承运人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零六条&emsp;托运人应当按照约定的方式包装货物。对包装方式没有约定或者约定不明确的，适用本法第一百五十六条的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>托运人违反前款规定的，承运人可以拒绝运输。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零七条&emsp;托运人托运易燃、易爆、有毒、有腐蚀性、有放射性等危险物品的，应当按照国家有关危险物品运输的规定对危险物品妥善包装，作出危险物标志和标签，并将有关危险物品的名称、性质和防范措施的书面材料提交承运人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>托运人违反前款规定的，承运人可以拒绝运输，也可以采取相应措施以避免损失的发生，因此产生的费用由托运人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零八条&emsp;在承运人将货物交付收货人之前，托运人可以要求承运人中止运输、返还货物、变更到达地或者将货物交给其他收货人，但应当赔偿承运人因此受到的损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百零九条&emsp;货物运输到达后，承运人知道收货人的，应当及时通知收货人，收货人应当及时提货。收货人逾期提货的，应当向承运人支付保管费等费用。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十条&emsp;收货人提货时应当按照约定的期限检验货物。对检验货物的期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，应当在合理期限内检验货物。收货人在约定的期限或者合理期限内对货物的数量、毁损等未提出异议的，视为承运人已经按照运输单证的记载交付的初步证据。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十一条&emsp;承运人对运输过程中货物的毁损、灭失承担损害赔偿责任，但承运人证明货物的毁损、灭失是因不可抗力、货物本身的自然性质或者合理损耗以及托运人、收货人的过错造成的，不承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十二条&emsp;货物的毁损、灭失的赔偿额，当事人有约定的，按照其约定；没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，按照交付或者应当交付时货物到达地的市场价格计算。法律、行政法规对赔偿额的计算方法和赔偿限额另有规定的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十三条&emsp;两个以上承运人以同一运输方式联运的，与托运人订立合同的承运人应当对全程运输承担责任。损失发生在某一运输区段的，与托运人订立合同的承运人和该区段的承运人承担连带责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十四条&emsp;货物在运输过程中因不可抗力灭失，未收取运费的，承运人不得要求支付运费；已收取运费的，托运人可以要求返还。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十五条&emsp;托运人或者收货人不支付运费、保管费以及其他运输费用的，承运人对相应的运输货物享有留置权，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十六条&emsp;收货人不明或者收货人无正当理由拒绝受领货物的，依照本法第一百零一条的规定，承运人可以提存货物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第四节&emsp;多式联运合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十七条&emsp;多式联运经营人负责履行或者组织履行多式联运合同，对全程运输享有承运人的权利，承担承运人的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十八条&emsp;多式联运经营人可以与参加多式联运的各区段承运人就多式联运合同的各区段运输约定相互之间的责任，但该约定不影响多式联运经营人对全程运输承担的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百一十九条&emsp;多式联运经营人收到托运人交付的货物时，应当签发多式联运单据。按照托运人的要求，多式联运单据可以是可转让单据，也可以是不可转让单据。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十条&emsp;因托运人托运货物时的过错造成多式联运经营人损失的，即使托运人已经转让多式联运单据，托运人仍然应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十一条&emsp;货物的毁损、灭失发生于多式联运的某一运输区段的，多式联运经营人的赔偿责任和责任限额，适用调整该区段运输方式的有关法律规定。货物毁损、灭失发生的运输区段不能确定的，依照本章规定承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十八章</span> 技术合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第一节&emsp;一般规定</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十二条&emsp;技术合同是当事人就技术开发、转让、咨询或者服务订立的确立相互之间权利和义务的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十三条&emsp;订立技术合同，应当有利于科学技术的进步，加速科学技术成果的转化、应用和推广。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十四条&emsp;技术合同的内容由当事人约定，一般包括以下条款：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）项目名称；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）标的的内容、范围和要求；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）履行的计划、进度、期限、地点、地域和方式；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）技术情报和资料的保密；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）风险责任的承担；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（六）技术成果的归属和收益的分成办法；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（七）验收标准和方法；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（八）价款、报酬或者使用费及其支付方式；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（九）违约金或者损失赔偿的计算方法；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（十）解决争议的方法；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（十一）名词和术语的解释。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>与履行合同有关的技术背景资料、可行性论证和技术评价报告、项目任务书和计划书、技术标准、技术规范、原始设计和工艺文件，以及其他技术文档，按照当事人的约定可以作为合同的组成部分。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术合同涉及专利的，应当注明发明创造的名称、专利申请人和专利权人、申请日期、申请号、专利号以及专利权的有效期限。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十五条&emsp;技术合同价款、报酬或者使用费的支付方式由当事人约定，可以采取一次总算、一次总付或者一次总算、分期支付，也可以采取提成支付或者提成支付附加预付入门费的方式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>约定提成支付的，可以按照产品价格、实施专利和使用技术秘密后新增的产值、利润或者产品销售额的一定比例提成，也可以按照约定的其他方式计算。提成支付的比例可以采取固定比例、逐年递增比例或者逐年递减比例。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>约定提成支付的，当事人应当在合同中约定查阅有关会计帐目的办法。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十六条&emsp;职务技术成果的使用权、转让权属于法人或者其他组织的，法人或者其他组织可以就该项职务技术成果订立技术合同。法人或者其他组织应当从使用和转让该项职务技术成果所取得的收益中提取一定比例，对完成该项职务技术成果的个人给予奖励或者报酬。法人或者其他组织订立技术合同转让职务技术成果时，职务技术成果的完成人享有以同等条件优先受让的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>职务技术成果是执行法人或者其他组织的工作任务，或者主要是利用法人或者其他组织的物质技术条件所完成的技术成果。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十七条&emsp;非职务技术成果的使用权、转让权属于完成技术成果的个人，完成技术成果的个人可以就该项非职务技术成果订立技术合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十八条&emsp;完成技术成果的个人有在有关技术成果文件上写明自己是技术成果完成者的权利和取得荣誉证书、奖励的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百二十九条&emsp;非法垄断技术、妨碍技术进步或者侵害他人技术成果的技术合同无效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二节&emsp;技术开发合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十条&emsp;技术开发合同是指当事人之间就新技术、新产品、新工艺或者新材料及其系统的研究开发所订立的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术开发合同包括委托开发合同和合作开发合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术开发合同应当采用书面形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人之间就具有产业应用价值的科技成果实施转化订立的合同，参照技术开发合同的规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十一条&emsp;委托开发合同的委托人应当按照约定支付研究开发经费和报酬；提供技术资料、原始数据；完成协作事项；接受研究开发成果。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十二条&emsp;委托开发合同的研究开发人应当按照约定制定和实施研究开发计划；合理使用研究开发经费；按期完成研究开发工作，交付研究开发成果，提供有关的技术资料和必要的技术指导，帮助委托人掌握研究开发成果。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十三条&emsp;委托人违反约定造成研究开发工作停滞、延误或者失败的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十四条&emsp;研究开发人违反约定造成研究开发工作停滞、延误或者失败的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十五条&emsp;合作开发合同的当事人应当按照约定进行投资，包括以技术进行投资；分工参与研究开发工作；协作配合研究开发工作。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十六条&emsp;合作开发合同的当事人违反约定造成研究开发工作停滞、延误或者失败的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十七条&emsp;因作为技术开发合同标的的技术已经由他人公开，致使技术开发合同的履行没有意义的，当事人可以解除合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十八条&emsp;在技术开发合同履行过程中，因出现无法克服的技术困难，致使研究开发失败或者部分失败的，该风险责任由当事人约定。没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，风险责任由当事人合理分担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人一方发现前款规定的可能致使研究开发失败或者部分失败的情形时，应当及时通知另一方并采取适当措施减少损失。没有及时通知并采取适当措施，致使损失扩大的，应当就扩大的损失承担责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百三十九条&emsp;委托开发完成的发明创造，除当事人另有约定的以外，申请专利的权利属于研究开发人。研究开发人取得专利权的，委托人可以免费实施该专利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>研究开发人转让专利申请权的，委托人享有以同等条件优先受让的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十条&emsp;合作开发完成的发明创造，除当事人另有约定的以外，申请专利的权利属于合作开发的当事人共有。当事人一方转让其共有的专利申请权的，其他各方享有以同等条件优先受让的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>合作开发的当事人一方声明放弃其共有的专利申请权的，可以由另一方单独申请或者由其他各方共同申请。申请人取得专利权的，放弃专利申请权的一方可以免费实施该专利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>合作开发的当事人一方不同意申请专利的，另一方或者其他各方不得申请专利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十一条&emsp;委托开发或者合作开发完成的技术秘密成果的使用权、转让权以及利益的分配办法，由当事人约定。没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，当事人均有使用和转让的权利，但委托开发的研究开发人不得在向委托人交付研究开发成果之前，将研究开发成果转让给第三人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第三节&emsp;技术转让合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十二条&emsp;技术转让合同包括专利权转让、专利申请权转让、技术秘密转让、专利实施许可合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术转让合同应当采用书面形式。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十三条&emsp;技术转让合同可以约定让与人和受让人实施专利或者使用技术秘密的范围，但不得限制技术竞争和技术发展。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十四条&emsp;专利实施许可合同只在该专利权的存续期间内有效。专利权有效期限届满或者专利权被宣布无效的，专利权人不得就该专利与他人订立专利实施许可合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十五条&emsp;专利实施许可合同的让与人应当按照约定许可受让人实施专利，交付实施专利有关的技术资料，提供必要的技术指导。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十六条&emsp;专利实施许可合同的受让人应当按照约定实施专利，不得许可约定以外的第三人实施该专利；并按照约定支付使用费。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十七条&emsp;技术秘密转让合同的让与人应当按照约定提供技术资料，进行技术指导，保证技术的实用性、可靠性，承担保密义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十八条&emsp;技术秘密转让合同的受让人应当按照约定使用技术，支付使用费，承担保密义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百四十九条&emsp;技术转让合同的让与人应当保证自己是所提供的技术的合法拥有者，并保证所提供的技术完整、无误、有效，能够达到约定的目标。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十条&emsp;技术转让合同的受让人应当按照约定的范围和期限，对让与人提供的技术中尚未公开的秘密部分，承担保密义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十一条&emsp;让与人未按照约定转让技术的，应当返还部分或者全部使用费，并应当承担违约责任；实施专利或者使用技术秘密超越约定的范围的，违反约定擅自许可第三人实施该项专利或者使用该项技术秘密的，应当停止违约行为，承担违约责任；违反约定的保密义务的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十二条&emsp;受让人未按照约定支付使用费的，应当补交使用费并按照约定支付违约金；不补交使用费或者支付违约金的，应当停止实施专利或者使用技术秘密，交还技术资料，承担违约责任；实施专利或者使用技术秘密超越约定的范围的，未经让与人同意擅自许可第三人实施该专利或者使用该技术秘密的，应当停止违约行为，承担违约责任；违反约定的保密义务的，应当承担违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十三条&emsp;受让人按照约定实施专利、使用技术秘密侵害他人合法权益的，由让与人承担责任，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十四条&emsp;当事人可以按照互利的原则，在技术转让合同中约定实施专利、使用技术秘密后续改进的技术成果的分享办法。没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，一方后续改进的技术成果，其他各方无权分享。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十五条&emsp;法律、行政法规对技术进出口合同或者专利、专利申请合同另有规定的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第四节&emsp;技术咨询合同和技术服务合同</span></b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十六条&emsp;技术咨询合同包括就特定技术项目提供可行性论证、技术预测、专题技术调查、分析评价报告等合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术服务合同是指当事人一方以技术知识为另一方解决特定技术问题所订立的合同，不包括建设工程合同和承揽合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十七条&emsp;技术咨询合同的委托人应当按照约定阐明咨询的问题，提供技术背景材料及有关技术资料、数据；接受受托人的工作成果，支付报酬。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十八条&emsp;技术咨询合同的受托人应当按照约定的期限完成咨询报告或者解答问题；提出的咨询报告应当达到约定的要求。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百五十九条&emsp;技术咨询合同的委托人未按照约定提供必要的资料和数据，影响工作进度和质量，不接受或者逾期接受工作成果的，支付的报酬不得追回，未支付的报酬应当支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术咨询合同的受托人未按期提出咨询报告或者提出的咨询报告不符合约定的，应当承担减收或者免收报酬等违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术咨询合同的委托人按照受托人符合约定要求的咨询报告和意见作出决策所造成的损失，由委托人承担，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十条&emsp;技术服务合同的委托人应当按照约定提供工作条件，完成配合事项；接受工作成果并支付报酬。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十一条&emsp;技术服务合同的受托人应当按照约定完成服务项目，解决技术问题，保证工作质量，并传授解决技术问题的知识。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十二条&emsp;技术服务合同的委托人不履行合同义务或者履行合同义务不符合约定，影响工作进度和质量，不接受或者逾期接受工作成果的，支付的报酬不得追回，未支付的报酬应当支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>技术服务合同的受托人未按照合同约定完成服务工作的，应当承担免收报酬等违约责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十三条&emsp;在技术咨询合同、技术服务合同履行过程中，受托人利用委托人提供的技术资料和工作条件完成的新的技术成果，属于受托人。委托人利用受托人的工作成果完成的新的技术成果，属于委托人。当事人另有约定的，按照其约定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十四条&emsp;法律、行政法规对技术中介合同、技术培训合同另有规定的，依照其规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第十九章</span> 保管合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十五条&emsp;保管合同是保管人保管寄存人交付的保管物，并返还该物的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十六条&emsp;寄存人应当按照约定向保管人支付保管费。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人对保管费没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，保管是无偿的。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十七条&emsp;保管合同自保管物交付时成立，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十八条&emsp;寄存人向保管人交付保管物的，保管人应当给付保管凭证，但另有交易习惯的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百六十九条&emsp;保管人应当妥善保管保管物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人可以约定保管场所或者方法。除紧急情况或者为了维护寄存人利益的以外，不得擅自改变保管场所或者方法。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十条&emsp;寄存人交付的保管物有瑕疵或者按照保管物的性质需要采取特殊保管措施的，寄存人应当将有关情况告知保管人。寄存人未告知，致使保管物受损失的，保管人不承担损害赔偿责任；保管人因此受损失的，除保管人知道或者应当知道并且未采取补救措施的以外，寄存人应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十一条&emsp;保管人不得将保管物转交第三人保管，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>保管人违反前款规定，将保管物转交第三人保管，对保管物造成损失的，应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十二条&emsp;保管人不得使用或者许可第三人使用保管物，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十三条&emsp;第三人对保管物主张权利的，除依法对保管物采取保全或者执行的以外，保管人应当履行向寄存人返还保管物的义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三人对保管人提起诉讼或者对保管物申请扣押的，保管人应当及时通知寄存人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十四条&emsp;保管期间，因保管人保管不善造成保管物毁损、灭失的，保管人应当承担损害赔偿责任，但保管是无偿的，保管人证明自己没有重大过失的，不承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十五条&emsp;寄存人寄存货币、有价证券或者其他贵重物品的，应当向保管人声明，由保管人验收或者封存。寄存人未声明的，该物品毁损、灭失后，保管人可以按照一般物品予以赔偿。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十六条&emsp;寄存人可以随时领取保管物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人对保管期间没有约定或者约定不明确的，保管人可以随时要求寄存人领取保管物；约定保管期间的，保管人无特别事由，不得要求寄存人提前领取保管物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十七条&emsp;保管期间届满或者寄存人提前领取保管物的，保管人应当将原物及其孳息归还寄存人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十八条&emsp;保管人保管货币的，可以返还相同种类、数量的货币。保管其他可替代物的，可以按照约定返还相同种类、品质、数量的物品。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百七十九条&emsp;有偿的保管合同，寄存人应当按照约定的期限向保管人支付保管费。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>当事人对支付期限没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，应当在领取保管物的同时支付。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十条&emsp;寄存人未按照约定支付保管费以及其他费用的，保管人对保管物享有留置权，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二十章</span> 仓储合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十一条&emsp;仓储合同是保管人储存存货人交付的仓储物，存货人支付仓储费的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十二条&emsp;仓储合同自成立时生效。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十三条&emsp;储存易燃、易爆、有毒、有腐蚀性、有放射性等危险物品或者易变质物品，存货人应当说明该物品的性质，提供有关资料。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>存货人违反前款规定的，保管人可以拒收仓储物，也可以采取相应措施以避免损失的发生，因此产生的费用由存货人承担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>保管人储存易燃、易爆、有毒、有腐蚀性、有放射性等危险物品的，应当具备相应的保管条件。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十四条&emsp;保管人应当按照约定对入库仓储物进行验收。保管人验收时发现入库仓储物与约定不符合的，应当及时通知存货人。保管人验收后，发生仓储物的品种、数量、质量不符合约定的，保管人应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十五条&emsp;存货人交付仓储物的，保管人应当给付仓单。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十六条&emsp;保管人应当在仓单上签字或者盖章。仓单包括下列事项：</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（一）存货人的名称或者姓名和住所；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（二）仓储物的品种、数量、质量、包装、件数和标记；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（三）仓储物的损耗标准；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（四）储存场所；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（五）储存期间；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（六）仓储费；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（七）仓储物已经办理保险的，其保险金额、期间以及保险人的名称；</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>（八）填发人、填发地和填发日期。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十七条&emsp;仓单是提取仓储物的凭证。存货人或者仓单持有人在仓单上背书并经保管人签字或者盖章的，可以转让提取仓储物的权利。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十八条&emsp;保管人根据存货人或者仓单持有人的要求，应当同意其检查仓储物或者提取样品。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百八十九条&emsp;保管人对入库仓储物发现有变质或者其他损坏的，应当及时通知存货人或者仓单持有人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十条&emsp;保管人对入库仓储物发现有变质或者其他损坏，危及其他仓储物的安全和正常保管的，应当催告存货人或者仓单持有人作出必要的处置。因情况紧急，保管人可以作出必要的处置，但事后应当将该情况及时通知存货人或者仓单持有人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十一条&emsp;当事人对储存期间没有约定或者约定不明确的，存货人或者仓单持有人可以随时提取仓储物，保管人也可以随时要求存货人或者仓单持有人提取仓储物，但应当给予必要的准备时间。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十二条&emsp;储存期间届满，存货人或者仓单持有人应当凭仓单提取仓储物。存货人或者仓单持有人逾期提取的，应当加收仓储费；提前提取的，不减收仓储费。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十三条&emsp;储存期间届满，存货人或者仓单持有人不提取仓储物的，保管人可以催告其在合理期限内提取，逾期不提取的，保管人可以提存仓储物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十四条&emsp;储存期间，因保管人保管不善造成仓储物毁损、灭失的，保管人应当承担损害赔偿责任。因仓储物的性质、包装不符合约定或者超过有效储存期造成仓储物变质、损坏的，保管人不承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十五条&emsp;本章没有规定的，适用保管合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二十一章</span> 委托合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十六条&emsp;委托合同是委托人和受托人约定，由受托人处理委托人事务的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十七条&emsp;委托人可以特别委托受托人处理一项或者数项事务，也可以概括委托受托人处理一切事务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十八条&emsp;委托人应当预付处理委托事务的费用。受托人为处理委托事务垫付的必要费用，委托人应当偿还该费用及其利息。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三百九十九条&emsp;受托人应当按照委托人的指示处理委托事务。需要变更委托人指示的，应当经委托人同意；因情况紧急，难以和委托人取得联系的，受托人应当妥善处理委托事务，但事后应当将该情况及时报告委托人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百条&emsp;受托人应当亲自处理委托事务。经委托人同意，受托人可以转委托。转委托经同意的，委托人可以就委托事务直接指示转委托的第三人，受托人仅就第三人的选任及其对第三人的指示承担责任。转委托未经同意的，受托人应当对转委托的第三人的行为承担责任，但在紧急情况下受托人为维护委托人的利益需要转委托的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零一条&emsp;受托人应当按照委托人的要求，报告委托事务的处理情况。委托合同终止时，受托人应当报告委托事务的结果。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零二条&emsp;受托人以自己的名义，在委托人的授权范围内与第三人订立的合同，第三人在订立合同时知道受托人与委托人之间的代理关系的，该合同直接约束委托人和第三人，但有确切证据证明该合同只约束受托人和第三人的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零三条&emsp;受托人以自己的名义与第三人订立合同时，第三人不知道受托人与委托人之间的代理关系的，受托人因第三人的原因对委托人不履行义务，受托人应当向委托人披露第三人，委托人因此可以行使受托人对第三人的权利，但第三人与受托人订立合同时如果知道该委托人就不会订立合同的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>受托人因委托人的原因对第三人不履行义务，受托人应当向第三人披露委托人，第三人因此可以选择受托人或者委托人作为相对人主张其权利，但第三人不得变更选定的相对人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>委托人行使受托人对第三人的权利的，第三人可以向委托人主张其对受托人的抗辩。第三人选定委托人作为其相对人的，委托人可以向第三人主张其对受托人的抗辩以及受托人对第三人的抗辩。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零四条&emsp;受托人处理委托事务取得的财产，应当转交给委托人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零五条&emsp;受托人完成委托事务的，委托人应当向其支付报酬。因不可归责于受托人的事由，委托合同解除或者委托事务不能完成的，委托人应当向受托人支付相应的报酬。当事人另有约定的，按照其约定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零六条&emsp;有偿的委托合同，因受托人的过错给委托人造成损失的，委托人可以要求赔偿损失。无偿的委托合同，因受托人的故意或者重大过失给委托人造成损失的，委托人可以要求赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>受托人超越权限给委托人造成损失的，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零七条&emsp;受托人处理委托事务时，因不可归责于自己的事由受到损失的，可以向委托人要求赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零八条&emsp;委托人经受托人同意，可以在受托人之外委托第三人处理委托事务。因此给受托人造成损失的，受托人可以向委托人要求赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百零九条&emsp;两个以上的受托人共同处理委托事务的，对委托人承担连带责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十条&emsp;委托人或者受托人可以随时解除委托合同。因解除合同给对方造成损失的，除不可归责于该当事人的事由以外，应当赔偿损失。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十一条&emsp;委托人或者受托人死亡、丧失民事行为能力或者破产的，委托合同终止，但当事人另有约定或者根据委托事务的性质不宜终止的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十二条&emsp;因委托人死亡、丧失民事行为能力或者破产，致使委托合同终止将损害委托人利益的，在委托人的继承人、法定代理人或者清算组织承受委托事务之前，受托人应当继续处理委托事务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十三条&emsp;因受托人死亡、丧失民事行为能力或者破产，致使委托合同终止的，受托人的继承人、法定代理人或者清算组织应当及时通知委托人。因委托合同终止将损害委托人利益的，在委托人作出善后处理之前，受托人的继承人、法定代理人或者清算组织应当采取必要措施。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二十二章</span> 行纪合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十四条&emsp;行纪合同是行纪人以自己的名义为委托人从事贸易活动，委托人支付报酬的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十五条&emsp;行纪人处理委托事务支出的费用，由行纪人负担，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十六条&emsp;行纪人占有委托物的，应当妥善保管委托物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十七条&emsp;委托物交付给行纪人时有瑕疵或者容易腐烂、变质的，经委托人同意，行纪人可以处分该物；和委托人不能及时取得联系的，行纪人可以合理处分。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十八条&emsp;行纪人低于委托人指定的价格卖出或者高于委托人指定的价格买入的，应当经委托人同意。未经委托人同意，行纪人补偿其差额的，该买卖对委托人发生效力。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>行纪人高于委托人指定的价格卖出或者低于委托人指定的价格买入的，可以按照约定增加报酬。没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，该利益属于委托人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>委托人对价格有特别指示的，行纪人不得违背该指示卖出或者买入。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百一十九条&emsp;行纪人卖出或者买入具有市场定价的商品，除委托人有相反的意思表示的以外，行纪人自己可以作为买受人或者出卖人。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>行纪人有前款规定情形的，仍然可以要求委托人支付报酬。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十条&emsp;行纪人按照约定买入委托物，委托人应当及时受领。经行纪人催告，委托人无正当理由拒绝受领的，行纪人依照本法第一百零一条的规定可以提存委托物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>委托物不能卖出或者委托人撤回出卖，经行纪人催告，委托人不取回或者不处分该物的，行纪人依照本法第一百零一条的规定可以提存委托物。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十一条&emsp;行纪人与第三人订立合同的，行纪人对该合同直接享有权利、承担义务。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第三人不履行义务致使委托人受到损害的，行纪人应当承担损害赔偿责任，但行纪人与委托人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十二条&emsp;行纪人完成或者部分完成委托事务的，委托人应当向其支付相应的报酬。委托人逾期不支付报酬的，行纪人对委托物享有留置权，但当事人另有约定的除外。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十三条&emsp;本章没有规定的，适用委托合同的有关规定。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>第二十三章</span> 居间合同</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十四条&emsp;居间合同是居间人向委托人报告订立合同的机会或者提供订立合同的媒介服务，委托人支付报酬的合同。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十五条&emsp;居间人应当就有关订立合同的事项向委托人如实报告。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>居间人故意隐瞒与订立合同有关的重要事实或者提供虚假情况，损害委托人利益的，不得要求支付报酬并应当承担损害赔偿责任。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十六条&emsp;居间人促成合同成立的，委托人应当按照约定支付报酬。对居间人的报酬没有约定或者约定不明确，依照本法第六十一条的规定仍不能确定的，根据居间人的劳务合理确定。因居间人提供订立合同的媒介服务而促成合同成立的，由该合同的当事人平均负担居间人的报酬。&emsp;</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>居间人促成合同成立的，居间活动的费用，由居间人负担。</span>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十七条&emsp;居间人未促成合同成立的，不得要求支付报酬，但可以要求委托人支付从事居间活动支出的必要费用。</span><sup>&nbsp;[2]</sup>&nbsp;
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<b><span>附</span> 则</b>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		<span>第四百二十八条&emsp;本法自</span><span>1999</span><span>年</span><span>10</span><span>月</span><span>1</span><span>日起施行，《中华人民共和国经济合同法》、《</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%B6%89%E5%A4%96%E7%BB%8F%E6%B5%8E%E5%90%88%E5%90%8C%E6%B3%95"><u><span>中华人民共和国涉外经济合同法</span></u></a><span>》、《</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%8A%80%E6%9C%AF%E5%90%88%E5%90%8C%E6%B3%95"><u><span>中华人民共和国技术合同法</span></u></a><span>》同时废止。</span><sup>&nbsp;[2]<a name="ref_[2]_9377592"></a></sup>&nbsp;
	</p>
	<p class="MsoNormal" style="background:#FFFFFF;">
		<a name="3"></a><a name="sub9377592_3"></a><a name="废止日期"></a><span>废止日期</span>
	</p>
	<p class="MsoNormal" style="background:#FFFFFF;">
		<a><u><span>编辑</span></u></a><a><u><span>&nbsp;</span></u><span>播报</span></a>
	</p>
	<p class="MsoNormal" style="text-indent:24pt;background:#FFFFFF;">
		2020<span>年</span><span>5</span><span>月</span><span>28</span><span>日，十三届全国人大三次会议表决通过了《</span><a href="https://baike.baidu.com/item/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E6%B0%91%E6%B3%95%E5%85%B8/19435116"><u><span>中华人民共和国民法典</span></u></a><span>》，自</span><span>2021</span><span>年</span><span>1</span><span>月</span><span>1</span><span>日起施行。《中华人民共和国合同法》同时废止。</span><sup>&nbsp;[1]</sup>
	</p>
	<p class="MsoNormal">
		&nbsp;
	</p>
</span></b>
</h1>
<p>
	<br />
</p>
              </div>
          </div>

          <div v-if="RowId =='中华人民共和国物权法'">
              <div class="Section0" style="layout-grid:15.6000pt;">
                  <h1 align="center" style="text-align:center;">
	<b><span>中华人民共和国物权法</span></b><b></b>
</h1>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	目&emsp;&emsp;录
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;第一编&emsp;总&emsp;&emsp;则<br />
&emsp;&emsp;&emsp;第一章&emsp;基本原则<br />
&emsp;&emsp;&emsp;第二章&emsp;物权的设立、变更、转让和消灭<br />
&emsp;&emsp;&emsp;&emsp;第一节&emsp;不动产登记<br />
&emsp;&emsp;&emsp;&emsp;第二节&emsp;动产交付<br />
&emsp;&emsp;&emsp;&emsp;第三节&emsp;其他规定<br />
&emsp;&emsp;&emsp;第三章&emsp;物权的保护<br />
&emsp;&emsp;第二编&emsp;所有权<br />
&emsp;&emsp;&emsp;第四章&emsp;一般规定<br />
&emsp;&emsp;&emsp;第五章&emsp;国家所有权和集体所有权、私人所有权<br />
&emsp;&emsp;&emsp;第六章&emsp;业主的建筑物区分所有权<br />
&emsp;&emsp;&emsp;第七章&emsp;相邻关系<br />
&emsp;&emsp;&emsp;第八章&emsp;共&emsp;&emsp;有<br />
&emsp;&emsp;&emsp;第九章&emsp;所有权取得的特别规定<br />
&emsp;&emsp;第三编&emsp;用益物权<br />
&emsp;&emsp;&emsp;第十章&emsp;一般规定<br />
&emsp;&emsp;&emsp;第十一章&emsp;土地承包经营权<br />
&emsp;&emsp;&emsp;第十二章&emsp;建设用地使用权<br />
&emsp;&emsp;&emsp;第十三章&emsp;宅基地使用权<br />
&emsp;&emsp;&emsp;第十四章&emsp;地役权<br />
&emsp;&emsp;第四编&emsp;担保物权<br />
&emsp;&emsp;&emsp;第十五章&emsp;一般规定<br />
&emsp;&emsp;&emsp;第十六章&emsp;抵押权<br />
&emsp;&emsp;&emsp;&emsp;第一节&emsp;一般抵押权<br />
&emsp;&emsp;&emsp;&emsp;第二节&emsp;最高额抵押权<br />
&emsp;&emsp;&emsp;第十七章&emsp;质&emsp;&emsp;权<br />
&emsp;&emsp;&emsp;&emsp;第一节&emsp;动产质权<br />
&emsp;&emsp;&emsp;&emsp;第二节&emsp;权利质权<br />
&emsp;&emsp;&emsp;第十八章&emsp;留置权<br />
&emsp;&emsp;第五编&emsp;占&emsp;&emsp;有<br />
&emsp;&emsp;&emsp;第十九章&emsp;占&emsp;&emsp;有<br />
&emsp;&emsp;附&emsp;&emsp;则
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第一编&emsp;总&emsp;&emsp;则
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第一章&emsp;基本原则
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一条</b>&emsp;为了维护国家基本经济制度，维护社会主义市场经济秩序，明确物的归属，发挥物的效用，保护权利人的物权，根据宪法，制定本法。<br />
&emsp;&emsp;<b>第二条</b>&emsp;因物的归属和利用而产生的民事关系，适用本法。<br />
&emsp;&emsp;本法所称物，包括不动产和动产。法律规定权利作为物权客体的，依照其规定。<br />
&emsp;&emsp;本法所称物权，是指权利人依法对特定的物享有直接支配和排他的权利，包括所有权、用益物权和担保物权。<br />
&emsp;&emsp;<b>第三条</b>&emsp;国家在社会主义初级阶段，坚持公有制为主体、多种所有制经济共同发展的基本经济制度。<br />
&emsp;&emsp;国家巩固和发展公有制经济，鼓励、支持和引导非公有制经济的发展。<br />
&emsp;&emsp;国家实行社会主义市场经济，保障一切市场主体的平等法律地位和发展权利。<br />
&emsp;&emsp;<b>第四条</b>&emsp;国家、集体、私人的物权和其他权利人的物权受法律保护，任何单位和个人不得侵犯。<br />
&emsp;&emsp;<b>第五条</b>&emsp;物权的种类和内容，由法律规定。<br />
&emsp;&emsp;<b>第六条</b>&emsp;不动产物权的设立、变更、转让和消灭，应当依照法律规定登记。动产物权的设立和转让，应当依照法律规定交付。<br />
&emsp;&emsp;<b>第七条</b>&emsp;物权的取得和行使，应当遵守法律，尊重社会公德，不得损害公共利益和他人合法权益。<br />
&emsp;&emsp;<b>第八条</b>&emsp;其他相关法律对物权另有特别规定的，依照其规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第二章&emsp;物权的设立、变更、转让和消灭
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第一节&emsp;不动产登记
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第九条</b>&emsp;不动产物权的设立、变更、转让和消灭，经依法登记，发生效力；未经登记，不发生效力，但法律另有规定的除外。<br />
&emsp;&emsp;依法属于国家所有的自然资源，所有权可以不登记。<br />
&emsp;&emsp;<b>第十条</b>&emsp;不动产登记，由不动产所在地的登记机构办理。<br />
&emsp;&emsp;国家对不动产实行统一登记制度。统一登记的范围、登记机构和登记办法，由法律、行政法规规定。<br />
&emsp;&emsp;<b>第十一条</b>&emsp;当事人申请登记，应当根据不同登记事项提供权属证明和不动产界址、面积等必要材料。<br />
&emsp;&emsp;<b>第十二条</b>&emsp;登记机构应当履行下列职责：<br />
&emsp;&emsp;（一）查验申请人提供的权属证明和其他必要材料；<br />
&emsp;&emsp;（二）就有关登记事项询问申请人；<br />
&emsp;&emsp;（三）如实、及时登记有关事项；<br />
&emsp;&emsp;（四）法律、行政法规规定的其他职责。<br />
&emsp;&emsp;申请登记的不动产的有关情况需要进一步证明的，登记机构可以要求申请人补充材料，必要时可以实地查看。<br />
&emsp;&emsp;<b>第十三条</b>&emsp;登记机构不得有下列行为：<br />
&emsp;&emsp;（一）要求对不动产进行评估；<br />
&emsp;&emsp;（二）以年检等名义进行重复登记；<br />
&emsp;&emsp;（三）超出登记职责范围的其他行为。<br />
&emsp;&emsp;<b>第十四条</b>&emsp;不动产物权的设立、变更、转让和消灭，依照法律规定应当登记的，自记载于不动产登记簿时发生效力。<br />
&emsp;&emsp;<b>第十五条</b>&emsp;当事人之间订立有关设立、变更、转让和消灭不动产物权的合同，除法律另有规定或者合同另有约定外，自合同成立时生效；未办理物权登记的，不影响合同效力。<br />
&emsp;&emsp;<b>第十六条</b>&emsp;不动产登记簿是物权归属和内容的根据。不动产登记簿由登记机构管理。<br />
&emsp;&emsp;<b>第十七条</b>&emsp;不动产权属证书是权利人享有该不动产物权的证明。不动产权属证书记载的事项，应当与不动产登记簿一致；记载不一致的，除有证据证明不动产登记簿确有错误外，以不动产登记簿为准。<br />
&emsp;&emsp;<b>第十八条</b>&emsp;权利人、利害关系人可以申请查询、复制登记资料，登记机构应当提供。<br />
&emsp;&emsp;<b>第十九条</b>&emsp;权利人、利害关系人认为不动产登记簿记载的事项错误的，可以申请更正登记。不动产登记簿记载的权利人书面同意更正或者有证据证明登记确有错误的，登记机构应当予以更正。<br />
&emsp;&emsp;不动产登记簿记载的权利人不同意更正的，利害关系人可以申请异议登记。登记机构予以异议登记的，申请人在异议登记之日起十五日内不起诉，异议登记失效。异议登记不当，造成权利人损害的，权利人可以向申请人请求损害赔偿。<br />
&emsp;&emsp;<b>第二十条</b>&emsp;当事人签订买卖房屋或者其他不动产物权的协议，为保障将来实现物权，按照约定可以向登记机构申请预告登记。预告登记后，未经预告登记的权利人同意，处分该不动产的，不发生物权效力。<br />
&emsp;&emsp;预告登记后，债权消灭或者自能够进行不动产登记之日起三个月内未申请登记的，预告登记失效。<br />
&emsp;&emsp;<b>第二十一条</b>&emsp;当事人提供虚假材料申请登记，给他人造成损害的，应当承担赔偿责任。<br />
&emsp;&emsp;因登记错误，给他人造成损害的，登记机构应当承担赔偿责任。登记机构赔偿后，可以向造成登记错误的人追偿。<br />
&emsp;&emsp;<b>第二十二条</b>&emsp;不动产登记费按件收取，不得按照不动产的面积、体积或者价款的比例收取。具体收费标准由国务院有关部门会同价格主管部门规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第二节&emsp;动产交付
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二十三条</b>&emsp;动产物权的设立和转让，自交付时发生效力，但法律另有规定的除外。<br />
&emsp;&emsp;<b>第二十四条</b>&emsp;船舶、航空器和机动车等物权的设立、变更、转让和消灭，未经登记，不得对抗善意第三人。<br />
&emsp;&emsp;<b>第二十五条</b>&emsp;动产物权设立和转让前，权利人已经依法占有该动产的，物权自法律行为生效时发生效力。<br />
&emsp;&emsp;<b>第二十六条</b>&emsp;动产物权设立和转让前，第三人依法占有该动产的，负有交付义务的人可以通过转让请求第三人返还原物的权利代替交付。<br />
&emsp;&emsp;<b>第二十七条</b>&emsp;动产物权转让时，双方又约定由出让人继续占有该动产的，物权自该约定生效时发生效力。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第三节&emsp;其他规定
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二十八条</b>&emsp;因人民法院、仲裁委员会的法律文书或者人民政府的征收决定等，导致物权设立、变更、转让或者消灭的，自法律文书或者人民政府的征收决定等生效时发生效力。<br />
&emsp;&emsp;<b>第二十九条</b>&emsp;因继承或者受遗赠取得物权的，自继承或者受遗赠开始时发生效力。<br />
&emsp;&emsp;<b>第三十条</b>&emsp;因合法建造、拆除房屋等事实行为设立或者消灭物权的，自事实行为成就时发生效力。<br />
&emsp;&emsp;<b>第三十一条</b>&emsp;依照本法第二十八条至第三十条规定享有不动产物权的，处分该物权时，依照法律规定需要办理登记的，未经登记，不发生物权效力。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第三章&emsp;物权的保护
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第三十二条</b>&emsp;物权受到侵害的，权利人可以通过和解、调解、仲裁、诉讼等途径解决。<br />
&emsp;&emsp;<b>第三十三条</b>&emsp;因物权的归属、内容发生争议的，利害关系人可以请求确认权利。<br />
&emsp;&emsp;<b>第三十四条</b>&emsp;无权占有不动产或者动产的，权利人可以请求返还原物。<br />
&emsp;&emsp;<b>第三十五条</b>&emsp;妨害物权或者可能妨害物权的，权利人可以请求排除妨害或者消除危险。<br />
&emsp;&emsp;<b>第三十六条</b>&emsp;造成不动产或者动产毁损的，权利人可以请求修理、重作、更换或者恢复原状。<br />
&emsp;&emsp;<b>第三十七条</b>&emsp;侵害物权，造成权利人损害的，权利人可以请求损害赔偿，也可以请求承担其他民事责任。<br />
&emsp;&emsp;<b>第三十八条</b>&emsp;本章规定的物权保护方式，可以单独适用，也可以根据权利被侵害的情形合并适用。<br />
&emsp;&emsp;侵害物权，除承担民事责任外，违反行政管理规定的，依法承担行政责任；构成犯罪的，依法追究刑事责任。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第二编&emsp;所有权
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第四章&emsp;一般规定
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第三十九条</b>&emsp;所有权人对自己的不动产或者动产，依法享有占有、使用、收益和处分的权利。<br />
&emsp;&emsp;<b>第四十条</b>&emsp;所有权人有权在自己的不动产或者动产上设立用益物权和担保物权。用益物权人、担保物权人行使权利，不得损害所有权人的权益。<br />
&emsp;&emsp;<b>第四十一条</b>&emsp;法律规定专属于国家所有的不动产和动产，任何单位和个人不能取得所有权。<br />
&emsp;&emsp;<b>第四十二条</b>&emsp;为了公共利益的需要，依照法律规定的权限和程序可以征收集体所有的土地和单位、个人的房屋及其他不动产。<br />
&emsp;&emsp;征收集体所有的土地，应当依法足额支付土地补偿费、安置补助费、地上附着物和青苗的补偿费等费用，安排被征地农民的社会保障费用，保障被征地农民的生活，维护被征地农民的合法权益。<br />
&emsp;&emsp;征收单位、个人的房屋及其他不动产，应当依法给予拆迁补偿，维护被征收人的合法权益；征收个人住宅的，还应当保障被征收人的居住条件。<br />
&emsp;&emsp;任何单位和个人不得贪污、挪用、私分、截留、拖欠征收补偿费等费用。<br />
&emsp;&emsp;<b>第四十三条</b>&emsp;国家对耕地实行特殊保护，严格限制农用地转为建设用地，控制建设用地总量。不得违反法律规定的权限和程序征收集体所有的土地。<br />
&emsp;&emsp;<b>第四十四条</b>&emsp;因抢险、救灾等紧急需要，依照法律规定的权限和程序可以征用单位、个人的不动产或者动产。被征用的不动产或者动产使用后，应当返还被征用人。单位、个人的不动产或者动产被征用或者征用后毁损、灭失的，应当给予补偿。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第五章&emsp;国家所有权和集体所有权、私人所有权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第四十五条</b>&emsp;法律规定属于国家所有的财产，属于国家所有即全民所有。<br />
&emsp;&emsp;国有财产由国务院代表国家行使所有权；法律另有规定的，依照其规定。<br />
&emsp;&emsp;<b>第四十六条</b>&emsp;矿藏、水流、海域属于国家所有。<br />
&emsp;&emsp;<b>第四十七条</b>&emsp;城市的土地，属于国家所有。法律规定属于国家所有的农村和城市郊区的土地，属于国家所有。<br />
&emsp;&emsp;<b>第四十八条</b>&emsp;森林、山岭、草原、荒地、滩涂等自然资源，属于国家所有，但法律规定属于集体所有的除外。<br />
&emsp;&emsp;<b>第四十九条</b>&emsp;法律规定属于国家所有的野生动植物资源，属于国家所有。<br />
&emsp;&emsp;<b>第五十条</b>&emsp;无线电频谱资源属于国家所有。<br />
&emsp;&emsp;<b>第五十一条</b>&emsp;法律规定属于国家所有的文物，属于国家所有。<br />
&emsp;&emsp;<b>第五十二条</b>&emsp;国防资产属于国家所有。<br />
&emsp;&emsp;铁路、公路、电力设施、电信设施和油气管道等基础设施，依照法律规定为国家所有的，属于国家所有。<br />
&emsp;&emsp;<b>第五十三条</b>&emsp;国家机关对其直接支配的不动产和动产，享有占有、使用以及依照法律和国务院的有关规定处分的权利。<br />
&emsp;&emsp;<b>第五十四条</b>&emsp;国家举办的事业单位对其直接支配的不动产和动产，享有占有、使用以及依照法律和国务院的有关规定收益、处分的权利。<br />
&emsp;&emsp;<b>第五十五条</b>&emsp;国家出资的企业，由国务院、地方人民政府依照法律、行政法规规定分别代表国家履行出资人职责，享有出资人权益。<br />
&emsp;&emsp;<b>第五十六条</b>&emsp;国家所有的财产受法律保护，禁止任何单位和个人侵占、哄抢、私分、截留、破坏。<br />
&emsp;&emsp;<b>第五十七条</b>&emsp;履行国有财产管理、监督职责的机构及其工作人员，应当依法加强对国有财产的管理、监督，促进国有财产保值增值，防止国有财产损失；滥用职权，玩忽职守，造成国有财产损失的，应当依法承担法律责任。<br />
&emsp;&emsp;违反国有财产管理规定，在企业改制、合并分立、关联交易等过程中，低价转让、合谋私分、擅自担保或者以其他方式造成国有财产损失的，应当依法承担法律责任。<br />
&emsp;&emsp;<b>第五十八条</b>&emsp;集体所有的不动产和动产包括：<br />
&emsp;&emsp;（一）法律规定属于集体所有的土地和森林、山岭、草原、荒地、滩涂；<br />
&emsp;&emsp;（二）集体所有的建筑物、生产设施、农田水利设施；<br />
&emsp;&emsp;（三）集体所有的教育、科学、文化、卫生、体育等设施；<br />
&emsp;&emsp;（四）集体所有的其他不动产和动产。<br />
&emsp;&emsp;<b>第五十九条</b>&emsp;农民集体所有的不动产和动产，属于本集体成员集体所有。<br />
&emsp;&emsp;下列事项应当依照法定程序经本集体成员决定：<br />
&emsp;&emsp;（一）土地承包方案以及将土地发包给本集体以外的单位或者个人承包；<br />
&emsp;&emsp;（二）个别土地承包经营权人之间承包地的调整；<br />
&emsp;&emsp;（三）土地补偿费等费用的使用、分配办法；<br />
&emsp;&emsp;（四）集体出资的企业的所有权变动等事项；<br />
&emsp;&emsp;（五）法律规定的其他事项。<br />
&emsp;&emsp;<b>第六十条</b>&emsp;对于集体所有的土地和森林、山岭、草原、荒地、滩涂等，依照下列规定行使所有权：<br />
&emsp;&emsp;（一）属于村农民集体所有的，由村集体经济组织或者村民委员会代表集体行使所有权；<br />
&emsp;&emsp;（二）分别属于村内两个以上农民集体所有的，由村内各该集体经济组织或者村民小组代表集体行使所有权；<br />
&emsp;&emsp;（三）属于乡镇农民集体所有的，由乡镇集体经济组织代表集体行使所有权。<br />
&emsp;&emsp;<b>第六十一条</b>&emsp;城镇集体所有的不动产和动产，依照法律、行政法规的规定由本集体享有占有、使用、收益和处分的权利。<br />
&emsp;&emsp;<b>第六十二条</b>&emsp;集体经济组织或者村民委员会、村民小组应当依照法律、行政法规以及章程、村规民约向本集体成员公布集体财产的状况。<br />
&emsp;&emsp;<b>第六十三条</b>&emsp;集体所有的财产受法律保护，禁止任何单位和个人侵占、哄抢、私分、破坏。<br />
&emsp;&emsp;集体经济组织、村民委员会或者其负责人作出的决定侵害集体成员合法权益的，受侵害的集体成员可以请求人民法院予以撤销。<br />
&emsp;&emsp;<b>第六十四条</b>&emsp;私人对其合法的收入、房屋、生活用品、生产工具、原材料等不动产和动产享有所有权。<br />
&emsp;&emsp;<b>第六十五条</b>&emsp;私人合法的储蓄、投资及其收益受法律保护。<br />
&emsp;&emsp;国家依照法律规定保护私人的继承权及其他合法权益。<br />
&emsp;&emsp;<b>第六十六条</b>&emsp;私人的合法财产受法律保护，禁止任何单位和个人侵占、哄抢、破坏。<br />
&emsp;&emsp;<b>第六十七条</b>&emsp;国家、集体和私人依法可以出资设立有限责任公司、股份有限公司或者其他企业。国家、集体和私人所有的不动产或者动产，投到企业的，由出资人按照约定或者出资比例享有资产收益、重大决策以及选择经营管理者等权利并履行义务。<br />
&emsp;&emsp;<b>第六十八条</b>&emsp;企业法人对其不动产和动产依照法律、行政法规以及章程享有占有、使用、收益和处分的权利。<br />
&emsp;&emsp;企业法人以外的法人，对其不动产和动产的权利，适用有关法律、行政法规以及章程的规定。<br />
&emsp;&emsp;<b>第六十九条</b>&emsp;社会团体依法所有的不动产和动产，受法律保护。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第六章&emsp;业主的建筑物区分所有权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第七十条</b>&emsp;业主对建筑物内的住宅、经营性用房等专有部分享有所有权，对专有部分以外的共有部分享有共有和共同管理的权利。<br />
&emsp;&emsp;<b>第七十一条</b>&emsp;业主对其建筑物专有部分享有占有、使用、收益和处分的权利。业主行使权利不得危及建筑物的安全，不得损害其他业主的合法权益。<br />
&emsp;&emsp;<b>第七十二条</b>&emsp;业主对建筑物专有部分以外的共有部分，享有权利，承担义务；不得以放弃权利不履行义务。<br />
&emsp;&emsp;业主转让建筑物内的住宅、经营性用房，其对共有部分享有的共有和共同管理的权利一并转让。<br />
&emsp;&emsp;<b>第七十三条</b>&emsp;建筑区划内的道路，属于业主共有，但属于城镇公共道路的除外。建筑区划内的绿地，属于业主共有，但属于城镇公共绿地或者明示属于个人的除外。建筑区划内的其他公共场所、公用设施和物业服务用房，属于业主共有。<br />
&emsp;&emsp;<b>第七十四条</b>&emsp;建筑区划内，规划用于停放汽车的车位、车库应当首先满足业主的需要。<br />
&emsp;&emsp;建筑区划内，规划用于停放汽车的车位、车库的归属，由当事人通过出售、附赠或者出租等方式约定。<br />
&emsp;&emsp;占用业主共有的道路或者其他场地用于停放汽车的车位，属于业主共有。<br />
&emsp;&emsp;<b>第七十五条</b>&emsp;业主可以设立业主大会，选举业主委员会。<br />
&emsp;&emsp;地方人民政府有关部门应当对设立业主大会和选举业主委员会给予指导和协助。<br />
&emsp;&emsp;<b>第七十六条</b>&emsp;下列事项由业主共同决定：<br />
&emsp;&emsp;（一）制定和修改业主大会议事规则；<br />
&emsp;&emsp;（二）制定和修改建筑物及其附属设施的管理规约；<br />
&emsp;&emsp;（三）选举业主委员会或者更换业主委员会成员；<br />
&emsp;&emsp;（四）选聘和解聘物业服务企业或者其他管理人；<br />
&emsp;&emsp;（五）筹集和使用建筑物及其附属设施的维修资金；<br />
&emsp;&emsp;（六）改建、重建建筑物及其附属设施；<br />
&emsp;&emsp;（七）有关共有和共同管理权利的其他重大事项。<br />
&emsp;&emsp;决定前款第五项和第六项规定的事项，应当经专有部分占建筑物总面积三分之二以上的业主且占总人数三分之二以上的业主同意。决定前款其他事项，应当经专有部分占建筑物总面积过半数的业主且占总人数过半数的业主同意。<br />
&emsp;&emsp;<b>第七十七条</b>&emsp;业主不得违反法律、法规以及管理规约，将住宅改变为经营性用房。业主将住宅改变为经营性用房的，除遵守法律、法规以及管理规约外，应当经有利害关系的业主同意。<br />
&emsp;&emsp;<b>第七十八条</b>&emsp;业主大会或者业主委员会的决定，对业主具有约束力。<br />
&emsp;&emsp;业主大会或者业主委员会作出的决定侵害业主合法权益的，受侵害的业主可以请求人民法院予以撤销。<br />
&emsp;&emsp;<b>第七十九条</b>&emsp;建筑物及其附属设施的维修资金，属于业主共有。经业主共同决定，可以用于电梯、水箱等共有部分的维修。维修资金的筹集、使用情况应当公布。<br />
&emsp;&emsp;<b>第八十条</b>&emsp;建筑物及其附属设施的费用分摊、收益分配等事项，有约定的，按照约定；没有约定或者约定不明确的，按照业主专有部分占建筑物总面积的比例确定。<br />
&emsp;&emsp;<b>第八十一条</b>&emsp;业主可以自行管理建筑物及其附属设施，也可以委托物业服务企业或者其他管理人管理。<br />
&emsp;&emsp;对建设单位聘请的物业服务企业或者其他管理人，业主有权依法更换。<br />
&emsp;&emsp;<b>第八十二条</b>&emsp;物业服务企业或者其他管理人根据业主的委托管理建筑区划内的建筑物及其附属设施，并接受业主的监督。<br />
&emsp;&emsp;<b>第八十三条</b>&emsp;业主应当遵守法律、法规以及管理规约。<br />
&emsp;&emsp;业主大会和业主委员会，对任意弃置垃圾、排放污染物或者噪声、违反规定饲养动物、违章搭建、侵占通道、拒付物业费等损害他人合法权益的行为，有权依照法律、法规以及管理规约，要求行为人停止侵害、消除危险、排除妨害、赔偿损失。业主对侵害自己合法权益的行为，可以依法向人民法院提起诉讼。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第七章&emsp;相邻关系
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第八十四条</b>&emsp;不动产的相邻权利人应当按照有利生产、方便生活、团结互助、公平合理的原则，正确处理相邻关系。<br />
&emsp;&emsp;<b>第八十五条</b>&emsp;法律、法规对处理相邻关系有规定的，依照其规定；法律、法规没有规定的，可以按照当地习惯。<br />
&emsp;&emsp;<b>第八十六条</b>&emsp;不动产权利人应当为相邻权利人用水、排水提供必要的便利。<br />
&emsp;&emsp;对自然流水的利用，应当在不动产的相邻权利人之间合理分配。对自然流水的排放，应当尊重自然流向。<br />
&emsp;&emsp;<b>第八十七条</b>&emsp;不动产权利人对相邻权利人因通行等必须利用其土地的，应当提供必要的便利。<br />
&emsp;&emsp;<b>第八十八条</b>&emsp;不动产权利人因建造、修缮建筑物以及铺设电线、电缆、水管、暖气和燃气管线等必须利用相邻土地、建筑物的，该土地、建筑物的权利人应当提供必要的便利。<br />
&emsp;&emsp;<b>第八十九条</b>&emsp;建造建筑物，不得违反国家有关工程建设标准，妨碍相邻建筑物的通风、采光和日照。<br />
&emsp;&emsp;<b>第九十条</b>&emsp;不动产权利人不得违反国家规定弃置固体废物，排放大气污染物、水污染物、噪声、光、电磁波辐射等有害物质。<br />
&emsp;&emsp;<b>第九十一条</b>&emsp;不动产权利人挖掘土地、建造建筑物、铺设管线以及安装设备等，不得危及相邻不动产的安全。<br />
&emsp;&emsp;<b>第九十二条</b>&emsp;不动产权利人因用水、排水、通行、铺设管线等利用相邻不动产的，应当尽量避免对相邻的不动产权利人造成损害；造成损害的，应当给予赔偿。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第八章&emsp;共&emsp;&emsp;有
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第九十三条</b>&emsp;不动产或者动产可以由两个以上单位、个人共有。共有包括按份共有和共同共有。<br />
&emsp;&emsp;<b>第九十四条</b>&emsp;按份共有人对共有的不动产或者动产按照其份额享有所有权。<br />
&emsp;&emsp;<b>第九十五条</b>&emsp;共同共有人对共有的不动产或者动产共同享有所有权。<br />
&emsp;&emsp;<b>第九十六条</b>&emsp;共有人按照约定管理共有的不动产或者动产；没有约定或者约定不明确的，各共有人都有管理的权利和义务。<br />
&emsp;&emsp;<b>第九十七条</b>&emsp;处分共有的不动产或者动产以及对共有的不动产或者动产作重大修缮的，应当经占份额三分之二以上的按份共有人或者全体共同共有人同意，但共有人之间另有约定的除外。<br />
&emsp;&emsp;<b>第九十八条</b>&emsp;对共有物的管理费用以及其他负担，有约定的，按照约定；没有约定或者约定不明确的，按份共有人按照其份额负担，共同共有人共同负担。<br />
&emsp;&emsp;<b>第九十九条</b>&emsp;共有人约定不得分割共有的不动产或者动产，以维持共有关系的，应当按照约定，但共有人有重大理由需要分割的，可以请求分割；没有约定或者约定不明确的，按份共有人可以随时请求分割，共同共有人在共有的基础丧失或者有重大理由需要分割时可以请求分割。因分割对其他共有人造成损害的，应当给予赔偿。<br />
&emsp;&emsp;<b>第一百条</b>&emsp;共有人可以协商确定分割方式。达不成协议，共有的不动产或者动产可以分割并且不会因分割减损价值的，应当对实物予以分割；难以分割或者因分割会减损价值的，应当对折价或者拍卖、变卖取得的价款予以分割。<br />
&emsp;&emsp;共有人分割所得的不动产或者动产有瑕疵的，其他共有人应当分担损失。<br />
&emsp;&emsp;<b>第一百零一条</b>&emsp;按份共有人可以转让其享有的共有的不动产或者动产份额。其他共有人在同等条件下享有优先购买的权利。<br />
&emsp;&emsp;<b>第一百零二条</b>&emsp;因共有的不动产或者动产产生的债权债务，在对外关系上，共有人享有连带债权、承担连带债务，但法律另有规定或者第三人知道共有人不具有连带债权债务关系的除外；在共有人内部关系上，除共有人另有约定外，按份共有人按照份额享有债权、承担债务，共同共有人共同享有债权、承担债务。偿还债务超过自己应当承担份额的按份共有人，有权向其他共有人追偿。<br />
&emsp;&emsp;<b>第一百零三条</b>&emsp;共有人对共有的不动产或者动产没有约定为按份共有或者共同共有，或者约定不明确的，除共有人具有家庭关系等外，视为按份共有。<br />
&emsp;&emsp;<b>第一百零四条</b>&emsp;按份共有人对共有的不动产或者动产享有的份额，没有约定或者约定不明确的，按照出资额确定；不能确定出资额的，视为等额享有。<br />
&emsp;&emsp;<b>第一百零五条</b>&emsp;两个以上单位、个人共同享有用益物权、担保物权的，参照本章规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第九章&emsp;所有权取得的特别规定
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百零六条</b>&emsp;无处分权人将不动产或者动产转让给受让人的，所有权人有权追回；除法律另有规定外，符合下列情形的，受让人取得该不动产或者动产的所有权：<br />
&emsp;&emsp;（一）受让人受让该不动产或者动产时是善意的；<br />
&emsp;&emsp;（二）以合理的价格转让；<br />
&emsp;&emsp;（三）转让的不动产或者动产依照法律规定应当登记的已经登记，不需要登记的已经交付给受让人。<br />
&emsp;&emsp;受让人依照前款规定取得不动产或者动产的所有权的，原所有权人有权向无处分权人请求赔偿损失。<br />
&emsp;&emsp;当事人善意取得其他物权的，参照前两款规定。<br />
&emsp;&emsp;<b>第一百零七条</b>&emsp;所有权人或者其他权利人有权追回遗失物。该遗失物通过转让被他人占有的，权利人有权向无处分权人请求损害赔偿，或者自知道或者应当知道受让人之日起二年内向受让人请求返还原物，但受让人通过拍卖或者向具有经营资格的经营者购得该遗失物的，权利人请求返还原物时应当支付受让人所付的费用。权利人向受让人支付所付费用后，有权向无处分权人追偿。<br />
&emsp;&emsp;<b>第一百零八条</b>&emsp;善意受让人取得动产后，该动产上的原有权利消灭，但善意受让人在受让时知道或者应当知道该权利的除外。<br />
&emsp;&emsp;<b>第一百零九条</b>&emsp;拾得遗失物，应当返还权利人。拾得人应当及时通知权利人领取，或者送交公安等有关部门。<br />
&emsp;&emsp;<b>第一百一十条</b>&emsp;有关部门收到遗失物，知道权利人的，应当及时通知其领取；不知道的，应当及时发布招领公告。<br />
&emsp;&emsp;<b>第一百一十一条</b>&emsp;拾得人在遗失物送交有关部门前，有关部门在遗失物被领取前，应当妥善保管遗失物。因故意或者重大过失致使遗失物毁损、灭失的，应当承担民事责任。<br />
&emsp;&emsp;<b>第一百一十二条</b>&emsp;权利人领取遗失物时，应当向拾得人或者有关部门支付保管遗失物等支出的必要费用。<br />
&emsp;&emsp;权利人悬赏寻找遗失物的，领取遗失物时应当按照承诺履行义务。<br />
&emsp;&emsp;拾得人侵占遗失物的，无权请求保管遗失物等支出的费用，也无权请求权利人按照承诺履行义务。<br />
&emsp;&emsp;<b>第一百一十三条</b>&emsp;遗失物自发布招领公告之日起六个月内无人认领的，归国家所有。<br />
&emsp;&emsp;<b>第一百一十四条</b>&emsp;拾得漂流物、发现埋藏物或者隐藏物的，参照拾得遗失物的有关规定。文物保护法等法律另有规定的，依照其规定。<br />
&emsp;&emsp;<b>第一百一十五条</b>&emsp;主物转让的，从物随主物转让，但当事人另有约定的除外。<br />
&emsp;&emsp;<b>第一百一十六条</b>&emsp;天然孳息，由所有权人取得；既有所有权人又有用益物权人的，由用益物权人取得。当事人另有约定的，按照约定。<br />
&emsp;&emsp;法定孳息，当事人有约定的，按照约定取得；没有约定或者约定不明确的，按照交易习惯取得。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第三编&emsp;用益物权
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十章&emsp;一般规定
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百一十七条</b>&emsp;用益物权人对他人所有的不动产或者动产，依法享有占有、使用和收益的权利。<br />
&emsp;&emsp;<b>第一百一十八条</b>&emsp;国家所有或者国家所有由集体使用以及法律规定属于集体所有的自然资源，单位、个人依法可以占有、使用和收益。<br />
&emsp;&emsp;<b>第一百一十九条</b>&emsp;国家实行自然资源有偿使用制度，但法律另有规定的除外。<br />
&emsp;&emsp;<b>第一百二十条</b>&emsp;用益物权人行使权利，应当遵守法律有关保护和合理开发利用资源的规定。所有权人不得干涉用益物权人行使权利。<br />
&emsp;&emsp;<b>第一百二十一条</b>&emsp;因不动产或者动产被征收、征用致使用益物权消灭或者影响用益物权行使的，用益物权人有权依照本法第四十二条、第四十四条的规定获得相应补偿。<br />
&emsp;&emsp;<b>第一百二十二条</b>&emsp;依法取得的海域使用权受法律保护。<br />
&emsp;&emsp;<b>第一百二十三条</b>&emsp;依法取得的探矿权、采矿权、取水权和使用水域、滩涂从事养殖、捕捞的权利受法律保护。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十一章&emsp;土地承包经营权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百二十四条</b>&emsp;农村集体经济组织实行家庭承包经营为基础、统分结合的双层经营体制。<br />
&emsp;&emsp;农民集体所有和国家所有由农民集体使用的耕地、林地、草地以及其他用于农业的土地，依法实行土地承包经营制度。<br />
&emsp;&emsp;<b>第一百二十五条</b>&emsp;土地承包经营权人依法对其承包经营的耕地、林地、草地等享有占有、使用和收益的权利，有权从事种植业、林业、畜牧业等农业生产。<br />
&emsp;&emsp;<b>第一百二十六条</b>&emsp;耕地的承包期为三十年。草地的承包期为三十年至五十年。林地的承包期为三十年至七十年；特殊林木的林地承包期，经国务院林业行政主管部门批准可以延长。<br />
&emsp;&emsp;前款规定的承包期届满，由土地承包经营权人按照国家有关规定继续承包。<br />
&emsp;&emsp;<b>第一百二十七条</b>&emsp;土地承包经营权自土地承包经营权合同生效时设立。<br />
&emsp;&emsp;县级以上地方人民政府应当向土地承包经营权人发放土地承包经营权证、林权证、草原使用权证，并登记造册，确认土地承包经营权。<br />
&emsp;&emsp;<b>第一百二十八条</b>&emsp;土地承包经营权人依照农村土地承包法的规定，有权将土地承包经营权采取转包、互换、转让等方式流转。流转的期限不得超过承包期的剩余期限。未经依法批准，不得将承包地用于非农建设。<br />
&emsp;&emsp;<b>第一百二十九条</b>&emsp;土地承包经营权人将土地承包经营权互换、转让，当事人要求登记的，应当向县级以上地方人民政府申请土地承包经营权变更登记；未经登记，不得对抗善意第三人。<br />
&emsp;&emsp;<b>第一百三十条</b>&emsp;承包期内发包人不得调整承包地。<br />
&emsp;&emsp;因自然灾害严重毁损承包地等特殊情形，需要适当调整承包的耕地和草地的，应当依照农村土地承包法等法律规定办理。<br />
&emsp;&emsp;<b>第一百三十一条</b>&emsp;承包期内发包人不得收回承包地。农村土地承包法等法律另有规定的，依照其规定。<br />
&emsp;&emsp;<b>第一百三十二条</b>&emsp;承包地被征收的，土地承包经营权人有权依照本法第四十二条第二款的规定获得相应补偿。<br />
&emsp;&emsp;<b>第一百三十三条</b>&emsp;通过招标、拍卖、公开协商等方式承包荒地等农村土地，依照农村土地承包法等法律和国务院的有关规定，其土地承包经营权可以转让、入股、抵押或者以其他方式流转。<br />
&emsp;&emsp;<b>第一百三十四条</b>&emsp;国家所有的农用地实行承包经营的，参照本法的有关规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十二章&emsp;建设用地使用权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百三十五条</b>&emsp;建设用地使用权人依法对国家所有的土地享有占有、使用和收益的权利，有权利用该土地建造建筑物、构筑物及其附属设施。<br />
&emsp;&emsp;<b>第一百三十六条</b>&emsp;建设用地使用权可以在土地的地表、地上或者地下分别设立。新设立的建设用地使用权，不得损害已设立的用益物权。<br />
&emsp;&emsp;<b>第一百三十七条</b>&emsp;设立建设用地使用权，可以采取出让或者划拨等方式。<br />
&emsp;&emsp;工业、商业、旅游、娱乐和商品住宅等经营性用地以及同一土地有两个以上意向用地者的，应当采取招标、拍卖等公开竞价的方式出让。<br />
&emsp;&emsp;严格限制以划拨方式设立建设用地使用权。采取划拨方式的，应当遵守法律、行政法规关于土地用途的规定。<br />
&emsp;&emsp;<b>第一百三十八条</b>&emsp;采取招标、拍卖、协议等出让方式设立建设用地使用权的，当事人应当采取书面形式订立建设用地使用权出让合同。<br />
&emsp;&emsp;建设用地使用权出让合同一般包括下列条款：<br />
&emsp;&emsp;（一）当事人的名称和住所；<br />
&emsp;&emsp;（二）土地界址、面积等；<br />
&emsp;&emsp;（三）建筑物、构筑物及其附属设施占用的空间；<br />
&emsp;&emsp;（四）土地用途；<br />
&emsp;&emsp;（五）使用期限；<br />
&emsp;&emsp;（六）出让金等费用及其支付方式；<br />
&emsp;&emsp;（七）解决争议的方法。<br />
&emsp;&emsp;<b>第一百三十九条</b>&emsp;设立建设用地使用权的，应当向登记机构申请建设用地使用权登记。建设用地使用权自登记时设立。登记机构应当向建设用地使用权人发放建设用地使用权证书。<br />
&emsp;&emsp;<b>第一百四十条</b>&emsp;建设用地使用权人应当合理利用土地，不得改变土地用途；需要改变土地用途的，应当依法经有关行政主管部门批准。<br />
&emsp;&emsp;<b>第一百四十一条</b>&emsp;建设用地使用权人应当依照法律规定以及合同约定支付出让金等费用。<br />
&emsp;&emsp;<b>第一百四十二条</b>&emsp;建设用地使用权人建造的建筑物、构筑物及其附属设施的所有权属于建设用地使用权人，但有相反证据证明的除外。<br />
&emsp;&emsp;<b>第一百四十三条</b>&emsp;建设用地使用权人有权将建设用地使用权转让、互换、出资、赠与或者抵押，但法律另有规定的除外。<br />
&emsp;&emsp;<b>第一百四十四条</b>&emsp;建设用地使用权转让、互换、出资、赠与或者抵押的，当事人应当采取书面形式订立相应的合同。使用期限由当事人约定，但不得超过建设用地使用权的剩余期限。<br />
&emsp;&emsp;<b>第一百四十五条</b>&emsp;建设用地使用权转让、互换、出资或者赠与的，应当向登记机构申请变更登记。<br />
&emsp;&emsp;<b>第一百四十六条</b>&emsp;建设用地使用权转让、互换、出资或者赠与的，附着于该土地上的建筑物、构筑物及其附属设施一并处分。<br />
&emsp;&emsp;<b>第一百四十七条</b>&emsp;建筑物、构筑物及其附属设施转让、互换、出资或者赠与的，该建筑物、构筑物及其附属设施占用范围内的建设用地使用权一并处分。<br />
&emsp;&emsp;<b>第一百四十八条</b>&emsp;建设用地使用权期间届满前，因公共利益需要提前收回该土地的，应当依照本法第四十二条的规定对该土地上的房屋及其他不动产给予补偿，并退还相应的出让金。<br />
&emsp;&emsp;<b>第一百四十九条</b>&emsp;住宅建设用地使用权期间届满的，自动续期。<br />
&emsp;&emsp;非住宅建设用地使用权期间届满后的续期，依照法律规定办理。该土地上的房屋及其他不动产的归属，有约定的，按照约定；没有约定或者约定不明确的，依照法律、行政法规的规定办理。<br />
&emsp;&emsp;<b>第一百五十条</b>&emsp;建设用地使用权消灭的，出让人应当及时办理注销登记。登记机构应当收回建设用地使用权证书。<br />
&emsp;&emsp;<b>第一百五十一条</b>&emsp;集体所有的土地作为建设用地的，应当依照土地管理法等法律规定办理。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十三章&emsp;宅基地使用权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百五十二条</b>&emsp;宅基地使用权人依法对集体所有的土地享有占有和使用的权利，有权依法利用该土地建造住宅及其附属设施。<br />
&emsp;&emsp;<b>第一百五十三条</b>&emsp;宅基地使用权的取得、行使和转让，适用土地管理法等法律和国家有关规定。<br />
&emsp;&emsp;<b>第一百五十四条</b>&emsp;宅基地因自然灾害等原因灭失的，宅基地使用权消灭。对失去宅基地的村民，应当重新分配宅基地。<br />
&emsp;&emsp;<b>第一百五十五条</b>&emsp;已经登记的宅基地使用权转让或者消灭的，应当及时办理变更登记或者注销登记。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十四章&emsp;地役权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百五十六条</b><span>&emsp;地役权人有权按照合同约定，利用他人的不动产</span>,以提高自己的不动产的效益。<br />
&emsp;&emsp;前款所称他人的不动产为供役地，自己的不动产为需役地。<br />
&emsp;&emsp;<b>第一百五十七条</b>&emsp;设立地役权，当事人应当采取书面形式订立地役权合同。<br />
&emsp;&emsp;地役权合同一般包括下列条款：<br />
&emsp;&emsp;（一）当事人的姓名或者名称和住所；<br />
&emsp;&emsp;（二）供役地和需役地的位置；<br />
&emsp;&emsp;（三）利用目的和方法；<br />
&emsp;&emsp;（四）利用期限；<br />
&emsp;&emsp;（五）费用及其支付方式；<br />
&emsp;&emsp;（六）解决争议的方法。<br />
&emsp;&emsp;<b>第一百五十八条</b>&emsp;地役权自地役权合同生效时设立。当事人要求登记的，可以向登记机构申请地役权登记；未经登记，不得对抗善意第三人。<br />
&emsp;&emsp;<b>第一百五十九条</b>&emsp;供役地权利人应当按照合同约定，允许地役权人利用其土地，不得妨害地役权人行使权利。<br />
&emsp;&emsp;<b>第一百六十条</b>&emsp;地役权人应当按照合同约定的利用目的和方法利用供役地，尽量减少对供役地权利人物权的限制。<br />
&emsp;&emsp;<b>第一百六十一条</b>&emsp;地役权的期限由当事人约定，但不得超过土地承包经营权、建设用地使用权等用益物权的剩余期限。<br />
&emsp;&emsp;<b>第一百六十二条</b>&emsp;土地所有权人享有地役权或者负担地役权的，设立土地承包经营权、宅基地使用权时，该土地承包经营权人、宅基地使用权人继续享有或者负担已设立的地役权。<br />
&emsp;&emsp;<b>第一百六十三条</b>&emsp;土地上已设立土地承包经营权、建设用地使用权、宅基地使用权等权利的，未经用益物权人同意，土地所有权人不得设立地役权。<br />
&emsp;&emsp;<b>第一百六十四条</b>&emsp;地役权不得单独转让。土地承包经营权、建设用地使用权等转让的，地役权一并转让，但合同另有约定的除外。<br />
&emsp;&emsp;<b>第一百六十五条</b>&emsp;地役权不得单独抵押。土地承包经营权、建设用地使用权等抵押的，在实现抵押权时，地役权一并转让。<br />
&emsp;&emsp;<b>第一百六十六条</b>&emsp;需役地以及需役地上的土地承包经营权、建设用地使用权部分转让时，转让部分涉及地役权的，受让人同时享有地役权。<br />
&emsp;&emsp;<b>第一百六十七条</b>&emsp;供役地以及供役地上的土地承包经营权、建设用地使用权部分转让时，转让部分涉及地役权的，地役权对受让人具有约束力。<br />
&emsp;&emsp;<b>第一百六十八条</b>&emsp;地役权人有下列情形之一的，供役地权利人有权解除地役权合同，地役权消灭：<br />
&emsp;&emsp;（一）违反法律规定或者合同约定，滥用地役权；<br />
&emsp;&emsp;（二）有偿利用供役地，约定的付款期间届满后在合理期限内经两次催告未支付费用。<br />
&emsp;&emsp;<b>第一百六十九条</b>&emsp;已经登记的地役权变更、转让或者消灭的，应当及时办理变更登记或者注销登记。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第四编&emsp;担保物权
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十五章&emsp;一般规定
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百七十条</b>&emsp;担保物权人在债务人不履行到期债务或者发生当事人约定的实现担保物权的情形，依法享有就担保财产优先受偿的权利，但法律另有规定的除外。<br />
&emsp;&emsp;<b>第一百七十一条</b>&emsp;债权人在借贷、买卖等民事活动中，为保障实现其债权，需要担保的，可以依照本法和其他法律的规定设立担保物权。<br />
&emsp;&emsp;第三人为债务人向债权人提供担保的，可以要求债务人提供反担保。反担保适用本法和其他法律的规定。<br />
&emsp;&emsp;<b>第一百七十二条</b>&emsp;设立担保物权，应当依照本法和其他法律的规定订立担保合同。担保合同是主债权债务合同的从合同。主债权债务合同无效，担保合同无效，但法律另有规定的除外。<br />
&emsp;&emsp;担保合同被确认无效后，债务人、担保人、债权人有过错的，应当根据其过错各自承担相应的民事责任。<br />
&emsp;&emsp;<b>第一百七十三条</b>&emsp;担保物权的担保范围包括主债权及其利息、违约金、损害赔偿金、保管担保财产和实现担保物权的费用。当事人另有约定的，按照约定。<br />
&emsp;&emsp;<b>第一百七十四条</b>&emsp;担保期间，担保财产毁损、灭失或者被征收等，担保物权人可以就获得的保险金、赔偿金或者补偿金等优先受偿。被担保债权的履行期未届满的，也可以提存该保险金、赔偿金或者补偿金等。<br />
&emsp;&emsp;<b>第一百七十五条</b>&emsp;第三人提供担保，未经其书面同意，债权人允许债务人转移全部或者部分债务的，担保人不再承担相应的担保责任。<br />
&emsp;&emsp;<b>第一百七十六条</b>&emsp;被担保的债权既有物的担保又有人的担保的，债务人不履行到期债务或者发生当事人约定的实现担保物权的情形，债权人应当按照约定实现债权；没有约定或者约定不明确，债务人自己提供物的担保的，债权人应当先就该物的担保实现债权；第三人提供物的担保的，债权人可以就物的担保实现债权，也可以要求保证人承担保证责任。提供担保的第三人承担担保责任后，有权向债务人追偿。<br />
&emsp;&emsp;<b>第一百七十七条</b>&emsp;有下列情形之一的，担保物权消灭：<br />
&emsp;&emsp;（一）主债权消灭；<br />
&emsp;&emsp;（二）担保物权实现；<br />
&emsp;&emsp;（三）债权人放弃担保物权；<br />
&emsp;&emsp;（四）法律规定担保物权消灭的其他情形。<br />
&emsp;&emsp;<b>第一百七十八条</b>&emsp;担保法与本法的规定不一致的，适用本法。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十六章&emsp;抵押权
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第一节&emsp;一般抵押权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第一百七十九条</b>&emsp;为担保债务的履行，债务人或者第三人不转移财产的占有，将该财产抵押给债权人的，债务人不履行到期债务或者发生当事人约定的实现抵押权的情形，债权人有权就该财产优先受偿。<br />
&emsp;&emsp;前款规定的债务人或者第三人为抵押人，债权人为抵押权人，提供担保的财产为抵押财产。<br />
&emsp;&emsp;<b>第一百八十条</b>&emsp;债务人或者第三人有权处分的下列财产可以抵押：<br />
&emsp;&emsp;（一）建筑物和其他土地附着物；<br />
&emsp;&emsp;（二）建设用地使用权；<br />
&emsp;&emsp;（三）以招标、拍卖、公开协商等方式取得的荒地等土地承包经营权；<br />
&emsp;&emsp;（四）生产设备、原材料、半成品、产品；<br />
&emsp;&emsp;（五）正在建造的建筑物、船舶、航空器；<br />
&emsp;&emsp;（六）交通运输工具；<br />
&emsp;&emsp;（七）法律、行政法规未禁止抵押的其他财产。<br />
&emsp;&emsp;抵押人可以将前款所列财产一并抵押。<br />
&emsp;&emsp;<b>第一百八十一条</b>&emsp;经当事人书面协议，企业、个体工商户、农业生产经营者可以将现有的以及将有的生产设备、原材料、半成品、产品抵押，债务人不履行到期债务或者发生当事人约定的实现抵押权的情形，债权人有权就实现抵押权时的动产优先受偿。<br />
&emsp;&emsp;<b>第一百八十二条</b>&emsp;以建筑物抵押的，该建筑物占用范围内的建设用地使用权一并抵押。以建设用地使用权抵押的，该土地上的建筑物一并抵押。<br />
&emsp;&emsp;抵押人未依照前款规定一并抵押的，未抵押的财产视为一并抵押。<br />
&emsp;&emsp;<b>第一百八十三条</b>&emsp;乡镇、村企业的建设用地使用权不得单独抵押。以乡镇、村企业的厂房等建筑物抵押的，其占用范围内的建设用地使用权一并抵押。<br />
&emsp;&emsp;<b>第一百八十四条</b>&emsp;下列财产不得抵押：<br />
&emsp;&emsp;（一）土地所有权；<br />
&emsp;&emsp;（二）耕地、宅基地、自留地、自留山等集体所有的土地使用权，但法律规定可以抵押的除外；<br />
&emsp;&emsp;（三）学校、幼儿园、医院等以公益为目的的事业单位、社会团体的教育设施、医疗卫生设施和其他社会公益设施；<br />
&emsp;&emsp;（四）所有权、使用权不明或者有争议的财产；<br />
&emsp;&emsp;（五）依法被查封、扣押、监管的财产；<br />
&emsp;&emsp;（六）法律、行政法规规定不得抵押的其他财产。<br />
&emsp;&emsp;<b>第一百八十五条</b>&emsp;设立抵押权，当事人应当采取书面形式订立抵押合同。<br />
&emsp;&emsp;抵押合同一般包括下列条款：<br />
&emsp;&emsp;（一）被担保债权的种类和数额；<br />
&emsp;&emsp;（二）债务人履行债务的期限；<br />
&emsp;&emsp;（三）抵押财产的名称、数量、质量、状况、所在地、所有权归属或者使用权归属；<br />
&emsp;&emsp;（四）担保的范围。<br />
&emsp;&emsp;<b>第一百八十六条</b>&emsp;抵押权人在债务履行期届满前，不得与抵押人约定债务人不履行到期债务时抵押财产归债权人所有。<br />
&emsp;&emsp;<b>第一百八十七条</b>&emsp;以本法第一百八十条第一款第一项至第三项规定的财产或者第五项规定的正在建造的建筑物抵押的，应当办理抵押登记。抵押权自登记时设立。<br />
&emsp;&emsp;<b>第一百八十八条</b>&emsp;以本法第一百八十条第一款第四项、第六项规定的财产或者第五项规定的正在建造的船舶、航空器抵押的，抵押权自抵押合同生效时设立；未经登记，不得对抗善意第三人。<br />
&emsp;&emsp;<b>第一百八十九条</b>&emsp;企业、个体工商户、农业生产经营者以本法第一百八十一条规定的动产抵押的，应当向抵押人住所地的工商行政管理部门办理登记。抵押权自抵押合同生效时设立；未经登记，不得对抗善意第三人。<br />
&emsp;&emsp;依照本法第一百八十一条规定抵押的，不得对抗正常经营活动中已支付合理价款并取得抵押财产的买受人。<br />
&emsp;&emsp;<b>第一百九十条</b>&emsp;订立抵押合同前抵押财产已出租的，原租赁关系不受该抵押权的影响。抵押权设立后抵押财产出租的，该租赁关系不得对抗已登记的抵押权。<br />
&emsp;&emsp;<b>第一百九十一条</b>&emsp;抵押期间，抵押人经抵押权人同意转让抵押财产的，应当将转让所得的价款向抵押权人提前清偿债务或者提存。转让的价款超过债权数额的部分归抵押人所有，不足部分由债务人清偿。<br />
&emsp;&emsp;抵押期间，抵押人未经抵押权人同意，不得转让抵押财产，但受让人代为清偿债务消灭抵押权的除外。<br />
&emsp;&emsp;<b>第一百九十二条</b>&emsp;抵押权不得与债权分离而单独转让或者作为其他债权的担保。债权转让的，担保该债权的抵押权一并转让，但法律另有规定或者当事人另有约定的除外。<br />
&emsp;&emsp;<b>第一百九十三条</b>&emsp;抵押人的行为足以使抵押财产价值减少的，抵押权人有权要求抵押人停止其行为。抵押财产价值减少的，抵押权人有权要求恢复抵押财产的价值，或者提供与减少的价值相应的担保。抵押人不恢复抵押财产的价值也不提供担保的，抵押权人有权要求债务人提前清偿债务。<br />
&emsp;&emsp;<b>第一百九十四条</b>&emsp;抵押权人可以放弃抵押权或者抵押权的顺位。抵押权人与抵押人可以协议变更抵押权顺位以及被担保的债权数额等内容，但抵押权的变更，未经其他抵押权人书面同意，不得对其他抵押权人产生不利影响。<br />
&emsp;&emsp;债务人以自己的财产设定抵押，抵押权人放弃该抵押权、抵押权顺位或者变更抵押权的，其他担保人在抵押权人丧失优先受偿权益的范围内免除担保责任，但其他担保人承诺仍然提供担保的除外。<br />
&emsp;&emsp;<b>第一百九十五条</b>&emsp;债务人不履行到期债务或者发生当事人约定的实现抵押权的情形，抵押权人可以与抵押人协议以抵押财产折价或者以拍卖、变卖该抵押财产所得的价款优先受偿。协议损害其他债权人利益的，其他债权人可以在知道或者应当知道撤销事由之日起一年内请求人民法院撤销该协议。<br />
&emsp;&emsp;抵押权人与抵押人未就抵押权实现方式达成协议的，抵押权人可以请求人民法院拍卖、变卖抵押财产。<br />
&emsp;&emsp;抵押财产折价或者变卖的，应当参照市场价格。<br />
&emsp;&emsp;<b>第一百九十六条</b>&emsp;依照本法第一百八十一条规定设定抵押的，抵押财产自下列情形之一发生时确定：<br />
&emsp;&emsp;（一）债务履行期届满，债权未实现；<br />
&emsp;&emsp;（二）抵押人被宣告破产或者被撤销；<br />
&emsp;&emsp;（三）当事人约定的实现抵押权的情形；<br />
&emsp;&emsp;（四）严重影响债权实现的其他情形。<br />
&emsp;&emsp;<b>第一百九十七条</b>&emsp;债务人不履行到期债务或者发生当事人约定的实现抵押权的情形，致使抵押财产被人民法院依法扣押的，自扣押之日起抵押权人有权收取该抵押财产的天然孳息或者法定孳息，但抵押权人未通知应当清偿法定孳息的义务人的除外。<br />
&emsp;&emsp;前款规定的孳息应当先充抵收取孳息的费用。<br />
&emsp;&emsp;<b>第一百九十八条</b>&emsp;抵押财产折价或者拍卖、变卖后，其价款超过债权数额的部分归抵押人所有，不足部分由债务人清偿。<br />
&emsp;&emsp;<b>第一百九十九条</b>&emsp;同一财产向两个以上债权人抵押的，拍卖、变卖抵押财产所得的价款依照下列规定清偿：<br />
&emsp;&emsp;（一）抵押权已登记的，按照登记的先后顺序清偿；顺序相同的，按照债权比例清偿；<br />
&emsp;&emsp;（二）抵押权已登记的先于未登记的受偿；<br />
&emsp;&emsp;（三）抵押权未登记的，按照债权比例清偿。<br />
&emsp;&emsp;<b>第二百条</b>&emsp;建设用地使用权抵押后，该土地上新增的建筑物不属于抵押财产。该建设用地使用权实现抵押权时，应当将该土地上新增的建筑物与建设用地使用权一并处分，但新增建筑物所得的价款，抵押权人无权优先受偿。<br />
&emsp;&emsp;<b>第二百零一条</b>&emsp;依照本法第一百八十条第一款第三项规定的土地承包经营权抵押的，或者依照本法第一百八十三条规定以乡镇、村企业的厂房等建筑物占用范围内的建设用地使用权一并抵押的，实现抵押权后，未经法定程序，不得改变土地所有权的性质和土地用途。<br />
&emsp;&emsp;<b>第二百零二条</b>&emsp;抵押权人应当在主债权诉讼时效期间行使抵押权；未行使的，人民法院不予保护。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第二节&emsp;最高额抵押权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百零三条</b>&emsp;为担保债务的履行，债务人或者第三人对一定期间内将要连续发生的债权提供担保财产的，债务人不履行到期债务或者发生当事人约定的实现抵押权的情形，抵押权人有权在最高债权额限度内就该担保财产优先受偿。<br />
&emsp;&emsp;最高额抵押权设立前已经存在的债权，经当事人同意，可以转入最高额抵押担保的债权范围。<br />
&emsp;&emsp;<b>第二百零四条</b>&emsp;最高额抵押担保的债权确定前，部分债权转让的，最高额抵押权不得转让，但当事人另有约定的除外。<br />
&emsp;&emsp;<b>第二百零五条</b>&emsp;最高额抵押担保的债权确定前，抵押权人与抵押人可以通过协议变更债权确定的期间、债权范围以及最高债权额，但变更的内容不得对其他抵押权人产生不利影响。<br />
&emsp;&emsp;<b>第二百零六条</b>&emsp;有下列情形之一的，抵押权人的债权确定：<br />
&emsp;&emsp;（一）约定的债权确定期间届满；<br />
&emsp;&emsp;（二）没有约定债权确定期间或者约定不明确，抵押权人或者抵押人自最高额抵押权设立之日起满二年后请求确定债权；<br />
&emsp;&emsp;（三）新的债权不可能发生；<br />
&emsp;&emsp;（四）抵押财产被查封、扣押；<br />
&emsp;&emsp;（五）债务人、抵押人被宣告破产或者被撤销；<br />
&emsp;&emsp;（六）法律规定债权确定的其他情形。<br />
&emsp;&emsp;<b>第二百零七条</b>&emsp;最高额抵押权除适用本节规定外，适用本章第一节一般抵押权的规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十七章&emsp;质&emsp;&emsp;权
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第一节&emsp;动产质权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百零八条</b>&emsp;为担保债务的履行，债务人或者第三人将其动产出质给债权人占有的，债务人不履行到期债务或者发生当事人约定的实现质权的情形，债权人有权就该动产优先受偿。<br />
&emsp;&emsp;前款规定的债务人或者第三人为出质人，债权人为质权人，交付的动产为质押财产。<br />
&emsp;&emsp;<b>第二百零九条</b>&emsp;法律、行政法规禁止转让的动产不得出质。<br />
&emsp;&emsp;<b>第二百一十条</b>&emsp;设立质权，当事人应当采取书面形式订立质权合同。<br />
&emsp;&emsp;质权合同一般包括下列条款：<br />
&emsp;&emsp;（一）被担保债权的种类和数额；<br />
&emsp;&emsp;（二）债务人履行债务的期限；<br />
&emsp;&emsp;（三）质押财产的名称、数量、质量、状况；<br />
&emsp;&emsp;（四）担保的范围；<br />
&emsp;&emsp;（五）质押财产交付的时间。<br />
&emsp;&emsp;<b>第二百一十一条</b>&emsp;质权人在债务履行期届满前，不得与出质人约定债务人不履行到期债务时质押财产归债权人所有。<br />
&emsp;&emsp;<b>第二百一十二条</b>&emsp;质权自出质人交付质押财产时设立。<br />
&emsp;&emsp;<b>第二百一十三条</b>&emsp;质权人有权收取质押财产的孳息，但合同另有约定的除外。<br />
&emsp;&emsp;前款规定的孳息应当先充抵收取孳息的费用。<br />
&emsp;&emsp;<b>第二百一十四条</b>&emsp;质权人在质权存续期间，未经出质人同意，擅自使用、处分质押财产，给出质人造成损害的，应当承担赔偿责任。<br />
&emsp;&emsp;<b>第二百一十五条</b>&emsp;质权人负有妥善保管质押财产的义务；因保管不善致使质押财产毁损、灭失的，应当承担赔偿责任。<br />
&emsp;&emsp;质权人的行为可能使质押财产毁损、灭失的，出质人可以要求质权人将质押财产提存，或者要求提前清偿债务并返还质押财产。<br />
&emsp;&emsp;<b>第二百一十六条</b>&emsp;因不能归责于质权人的事由可能使质押财产毁损或者价值明显减少，足以危害质权人权利的，质权人有权要求出质人提供相应的担保；出质人不提供的，质权人可以拍卖、变卖质押财产，并与出质人通过协议将拍卖、变卖所得的价款提前清偿债务或者提存。<br />
&emsp;&emsp;<b>第二百一十七条</b>&emsp;质权人在质权存续期间，未经出质人同意转质，造成质押财产毁损、灭失的，应当向出质人承担赔偿责任。<br />
&emsp;&emsp;<b>第二百一十八条</b>&emsp;质权人可以放弃质权。债务人以自己的财产出质，质权人放弃该质权的，其他担保人在质权人丧失优先受偿权益的范围内免除担保责任，但其他担保人承诺仍然提供担保的除外。<br />
&emsp;&emsp;<b>第二百一十九条</b>&emsp;债务人履行债务或者出质人提前清偿所担保的债权的，质权人应当返还质押财产。<br />
&emsp;&emsp;债务人不履行到期债务或者发生当事人约定的实现质权的情形，质权人可以与出质人协议以质押财产折价，也可以就拍卖、变卖质押财产所得的价款优先受偿。<br />
&emsp;&emsp;质押财产折价或者变卖的，应当参照市场价格。<br />
&emsp;&emsp;<b>第二百二十条</b>&emsp;出质人可以请求质权人在债务履行期届满后及时行使质权；质权人不行使的，出质人可以请求人民法院拍卖、变卖质押财产。<br />
&emsp;&emsp;出质人请求质权人及时行使质权，因质权人怠于行使权利造成损害的，由质权人承担赔偿责任。<br />
&emsp;&emsp;<b>第二百二十一条</b>&emsp;质押财产折价或者拍卖、变卖后，其价款超过债权数额的部分归出质人所有，不足部分由债务人清偿。<br />
&emsp;&emsp;<b>第二百二十二条</b>&emsp;出质人与质权人可以协议设立最高额质权。<br />
&emsp;&emsp;最高额质权除适用本节有关规定外，参照本法第十六章第二节最高额抵押权的规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第二节&emsp;权利质权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百二十三条</b>&emsp;债务人或者第三人有权处分的下列权利可以出质：<br />
&emsp;&emsp;（一）汇票、支票、本票；<br />
&emsp;&emsp;（二）债券、存款单；<br />
&emsp;&emsp;（三）仓单、提单；<br />
&emsp;&emsp;（四）可以转让的基金份额、股权；<br />
&emsp;&emsp;（五）可以转让的注册商标专用权、专利权、著作权等知识产权中的财产权；<br />
&emsp;&emsp;（六）应收账款；<br />
&emsp;&emsp;（七）法律、行政法规规定可以出质的其他财产权利。<br />
&emsp;&emsp;<b>第二百二十四条</b>&emsp;以汇票、支票、本票、债券、存款单、仓单、提单出质的，当事人应当订立书面合同。质权自权利凭证交付质权人时设立；没有权利凭证的，质权自有关部门办理出质登记时设立。<br />
&emsp;&emsp;<b>第二百二十五条</b>&emsp;汇票、支票、本票、债券、存款单、仓单、提单的兑现日期或者提货日期先于主债权到期的，质权人可以兑现或者提货，并与出质人协议将兑现的价款或者提取的货物提前清偿债务或者提存。<br />
&emsp;&emsp;<b>第二百二十六条</b>&emsp;以基金份额、股权出质的，当事人应当订立书面合同。以基金份额、证券登记结算机构登记的股权出质的，质权自证券登记结算机构办理出质登记时设立；以其他股权出质的，质权自工商行政管理部门办理出质登记时设立。<br />
&emsp;&emsp;基金份额、股权出质后，不得转让，但经出质人与质权人协商同意的除外。出质人转让基金份额、股权所得的价款，应当向质权人提前清偿债务或者提存。<br />
&emsp;&emsp;<b>第二百二十七条</b>&emsp;以注册商标专用权、专利权、著作权等知识产权中的财产权出质的，当事人应当订立书面合同。质权自有关主管部门办理出质登记时设立。<br />
&emsp;&emsp;知识产权中的财产权出质后，出质人不得转让或者许可他人使用，但经出质人与质权人协商同意的除外。出质人转让或者许可他人使用出质的知识产权中的财产权所得的价款，应当向质权人提前清偿债务或者提存。<br />
&emsp;&emsp;<b>第二百二十八条</b>&emsp;以应收账款出质的，当事人应当订立书面合同。质权自信贷征信机构办理出质登记时设立。<br />
&emsp;&emsp;应收账款出质后，不得转让，但经出质人与质权人协商同意的除外。出质人转让应收账款所得的价款，应当向质权人提前清偿债务或者提存。<br />
&emsp;&emsp;<b>第二百二十九条</b>&emsp;权利质权除适用本节规定外，适用本章第一节动产质权的规定。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十八章&emsp;留置权
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百三十条</b>&emsp;债务人不履行到期债务，债权人可以留置已经合法占有的债务人的动产，并有权就该动产优先受偿。<br />
&emsp;&emsp;前款规定的债权人为留置权人，占有的动产为留置财产。<br />
&emsp;&emsp;<b>第二百三十一条</b>&emsp;债权人留置的动产，应当与债权属于同一法律关系，但企业之间留置的除外。<br />
&emsp;&emsp;<b>第二百三十二条</b>&emsp;法律规定或者当事人约定不得留置的动产，不得留置。<br />
&emsp;&emsp;<b>第二百三十三条</b>&emsp;留置财产为可分物的，留置财产的价值应当相当于债务的金额。<br />
&emsp;&emsp;<b>第二百三十四条</b>&emsp;留置权人负有妥善保管留置财产的义务；因保管不善致使留置财产毁损、灭失的，应当承担赔偿责任。<br />
&emsp;&emsp;<b>第二百三十五条</b>&emsp;留置权人有权收取留置财产的孳息。<br />
&emsp;&emsp;前款规定的孳息应当先充抵收取孳息的费用。<br />
&emsp;&emsp;<b>第二百三十六条</b>&emsp;留置权人与债务人应当约定留置财产后的债务履行期间；没有约定或者约定不明确的，留置权人应当给债务人两个月以上履行债务的期间，但鲜活易腐等不易保管的动产除外。债务人逾期未履行的，留置权人可以与债务人协议以留置财产折价，也可以就拍卖、变卖留置财产所得的价款优先受偿。<br />
&emsp;&emsp;留置财产折价或者变卖的，应当参照市场价格。<br />
&emsp;&emsp;<b>第二百三十七条</b>&emsp;债务人可以请求留置权人在债务履行期届满后行使留置权；留置权人不行使的，债务人可以请求人民法院拍卖、变卖留置财产。<br />
&emsp;&emsp;<b>第二百三十八条</b>&emsp;留置财产折价或者拍卖、变卖后，其价款超过债权数额的部分归债务人所有，不足部分由债务人清偿。<br />
&emsp;&emsp;<b>第二百三十九条</b>&emsp;同一动产上已设立抵押权或者质权，该动产又被留置的，留置权人优先受偿。<br />
&emsp;&emsp;<b>第二百四十条</b>&emsp;留置权人对留置财产丧失占有或者留置权人接受债务人另行提供担保的，留置权消灭。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第五编&emsp;占&emsp;&emsp;有
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	第十九章&emsp;占&emsp;&emsp;有
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百四十一条</b>&emsp;基于合同关系等产生的占有，有关不动产或者动产的使用、收益、违约责任等，按照合同约定；合同没有约定或者约定不明确的，依照有关法律规定。<br />
&emsp;&emsp;<b>第二百四十二条</b>&emsp;占有人因使用占有的不动产或者动产，致使该不动产或者动产受到损害的，恶意占有人应当承担赔偿责任。<br />
&emsp;&emsp;<b>第二百四十三条</b>&emsp;不动产或者动产被占有人占有的，权利人可以请求返还原物及其孳息，但应当支付善意占有人因维护该不动产或者动产支出的必要费用。<br />
&emsp;&emsp;<b>第二百四十四条</b>&emsp;占有的不动产或者动产毁损、灭失，该不动产或者动产的权利人请求赔偿的，占有人应当将因毁损、灭失取得的保险金、赔偿金或者补偿金等返还给权利人；权利人的损害未得到足够弥补的，恶意占有人还应当赔偿损失。<br />
&emsp;&emsp;<b>第二百四十五条</b>&emsp;占有的不动产或者动产被侵占的，占有人有权请求返还原物；对妨害占有的行为，占有人有权请求排除妨害或者消除危险；因侵占或者妨害造成损害的，占有人有权请求损害赔偿。<br />
&emsp;&emsp;占有人返还原物的请求权，自侵占发生之日起一年内未行使的，该请求权消灭。
</p>
<p class="p" align="center" style="text-align:center;background:#FFFFFF;">
	附&emsp;&emsp;则
</p>
<p class="p" style="background:#FFFFFF;">
	&emsp;&emsp;<b>第二百四十六条</b>&emsp;法律、行政法规对不动产统一登记的范围、登记机构和登记办法作出规定前，地方性法规可以依照本法有关规定作出规定。<br />
&emsp;&emsp;<b>第二百四十七条</b><span>&emsp;本法自</span>2007年10月1日起施行。
</p>
<p class="MsoNormal">
	&nbsp;
</p>
              </div>
          </div>




        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "help",
  components: {
    leftMenu,
  },
  data() {
    return {
      activeText: "",
      pageNum: 10,
      total: 100,
      RowId: "",
      requestXmlPath: "",
      description: "",
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.RowId = this.$route.query.id;
    this.requestXmlPath = this.$route.query.father;
  },
  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "法律法规":
          // return 'ENTERPRISE QUALIFICATION'
          break;
        case "监管政策":
          // return 'INFORMATION DISCLOSURE'
          break;
        case "常见问题":
          return "COMMON PROBLEM";
          break;

        default:
          break;
      }
    },
  },
  methods: {
    goBack() {
      //this.$router.push('/help')
      if (
        this.RowId == "中华人民共和国担保法" ||
        this.RowId == "中华人民共和国合同法" ||
        this.RowId == "中华人民共和国物权法"
      ) {
        this.$router.push({ path: "/help", query: { id: "法律法规" } });
      }
    },
    activeMeun(data) {
      this.activeText = data;
    },
    //法律法规-查看详情
    handleClick(row) {
      console.log(row);
    },
    //法律法规-每页条数设置
    SizeChange(str) {
      console.log(str);
    },
    //法律法规-分页跳整
    CurrentChange(str) {
      console.log(str);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-page-header {
  height: 30px;
  margin-left: 10%;
}
/deep/ .el-page-header__left {
  width: 100%;
  align-items: center;
}
/deep/ .el-icon-back {
  font-size: $font-size-lv3;
}
/deep/ .el-page-header__title {
  font-size: $font-size-lv4;
}
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 35px;
}
.el-container {
  flex-wrap: wrap;
}
.topebanner {
  width: 100%;
  height: 195px;
}
.bg-box {
  width: 100%;
  display: flex;
  margin: 0 10%;
  .right-text {
    width: 964px;
    text-align: left;
    margin: 0 0 100px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
  }
  .detail-main-title {
    width: 100%;
    height: 85px;
    text-align: left;
    color: #000;
    font-size: 28px;
    margin-top: 20px;
    border-bottom: darkgray 1px solid;
  }
}
.detail-main {
  width: 100%;
}
.brief-introduction {
  width: 100%;
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  line-height: 30px;
  color: #999999;
}
.main-text {
  margin-top: 20px;
  overflow: auto;
}
</style>
<style>
@font-face {
  font-family: "Times New Roman";
}

@font-face {
  font-family: "宋体";
}

@font-face {
  font-family: "Wingdings";
}

@font-face {
  font-family: "Calibri";
}

p.MsoNormal {
  mso-style-name: 正文;
  mso-style-parent: "";
  margin: 0pt;
  margin-bottom: 0.0001pt;
  mso-pagination: none;
  text-align: justify;
  text-justify: inter-ideograph;
  font-family: Calibri;
  mso-fareast-font-family: 宋体;
  mso-bidi-font-family: "Times New Roman";
  font-size: 10.5pt;
  mso-font-kerning: 1pt;
}

span.msoIns {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: underline;
  text-underline: single;
  color: blue;
}

span.msoDel {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: line-through;
  color: red;
}

table.MsoNormalTable {
  mso-style-name: 普通表格;
  mso-style-parent: "";
  mso-style-noshow: yes;
  mso-tstyle-rowband-size: 0;
  mso-tstyle-colband-size: 0;
  mso-padding-alt: 0pt 5.4pt 0pt 5.4pt;
  mso-para-margin: 0pt;
  mso-para-margin-bottom: 0.0001pt;
  mso-pagination: widow-orphan;
  font-family: "Times New Roman";
  font-size: 10pt;
  mso-ansi-language: #0400;
  mso-fareast-language: #0400;
  mso-bidi-language: #0400;
}
@page {
  mso-page-border-surround-header: no;
  mso-page-border-surround-footer: no;
}
@page Section0 {
  margin-top: 72pt;
  margin-bottom: 72pt;
  margin-left: 90pt;
  margin-right: 90pt;
  size: 595.3pt 841.9pt;
  layout-grid: 15.6pt;
}
div.Section0 {
  page: Section0;
}
</style>


// WEBPACK FOOTER //
// src/views/details.vue